/* Українська — Ukrainian */
const uk = {
  nav: {
    home: 'Головна',
    imageConverter: 'Конвертер Зображень',
    imageCompressor: 'Компресор Зображень',
    otherTools: 'Інші Інструменти',
    resizeImage: 'Змінити Розмір',
    cropImage: 'Обрізати Зображення',
    photoEditor: 'Фоторедактор',
    removeBackground: 'Видалити Фон',
    watermarkImage: 'Водяний Знак',
    qrCodeGenerator: 'Генератор QR-кодів',
    qrCodeScanner: 'Сканер QR-кодів',
    aboutUs: 'Про Нас',
    faceBlur: 'Розмитість Обличчя',
  },

  hero: {
    heading: 'Усі Інструменти для Зображень, Які Вам Потрібні',
    subheading: 'Безкоштовні онлайн-інструменти для конвертації, стиснення, зміни розміру, обрізки та редагування зображень. Вся обробка відбувається у браузері — швидко та безпечно.',
  },

  tools: {
    compressImage: { title: 'Стиснути Зображення', desc: 'Стискайте JPG, PNG, SVG та GIF зі збереженням якості.' },
    resizeImage: { title: 'Змінити Розмір', desc: 'Змінюйте розмір у відсотках або пікселях.' },
    cropImage: { title: 'Обрізати Зображення', desc: 'Легко обрізайте JPG, PNG та GIF.' },
    convertToJpg: { title: 'Конвертувати у JPG', desc: 'Пакетна конвертація PNG, GIF, TIF, SVG, WEBP та інших у JPG.' },
    convertFromJpg: { title: 'Конвертація з JPG', desc: 'Конвертуйте зображення JPG у PNG та GIF.' },
    qrCodeGenerator: { title: 'Генератор QR-кодів', desc: 'Створюйте QR-коди для URL, тексту, WiFi, контактів тощо.' },
    qrCodeScanner: { title: 'Сканер QR-кодів', desc: 'Миттєво скануйте QR-коди камерою або завантаживши зображення.' },
    blurFace: { title: 'Розмитість Обличчя', desc: 'Автоматично виявляйте та розмивайте обличчя для захисту конфіденційності.' },
    removeBackground: { title: 'Видалити Фон', desc: 'Швидко видаляйте фон зображення з високою точністю.' },
    watermarkImage: { title: 'Водяний Знак', desc: 'Додавайте водяні знаки до зображень за лічені секунди.' },
  },

  whyChoose: {
    label: 'Чому Ми',
    heading: 'Розумніший Спосіб Редагування Зображень',
    subheading: 'Довіряють тисячі творців, дизайнерів та розробників по всьому світу.',
    reasons: {
      fast: { title: 'Блискавично Швидко', desc: 'Вся обробка відбувається безпосередньо у браузері. Без завантаження на зовнішні сервери.' },
      private: { title: '100% Безпечно та Конфіденційно', desc: 'Ваші файли ніколи не покидають пристрій. Ми не зберігаємо ваші зображення.' },
      noLimits: { title: 'Без Обмежень, Без Реєстрації', desc: 'Використовуйте всі інструменти скільки завгодно — абсолютно безкоштовно.' },
      quality: { title: 'Професійна Якість', desc: 'Наші алгоритми забезпечують результати професійного рівня.' },
      batch: { title: 'Пакетна Обробка', desc: 'Обробляйте декілька файлів одночасно.' },
      everywhere: { title: 'Працює Всюди', desc: 'Ідеально працює на комп\'ютері, планшеті та телефоні.' },
    },
    stats: {
      imagesProcessed: 'Oброблених Зображень',
      countriesServed: 'Обслуговуваних Країн',
      uptime: 'Час Роботи',
      freeTools: 'Безкоштовних Інструментів',
    },
  },

  footer: {
    tagline: 'Безкоштовні онлайн-інструменти для зображень — конвертуйте, стискайте, змінюйте розмір, обрізайте та редагуйте зображення за секунди.',
    imageTools: 'Інструменти Зображень',
    moreTools: 'Більше Інструментів',
    company: 'Компанія',
    contact: 'Контакт',
    allRightsReserved: 'Усі права захищено.',
    privacyPolicy: 'Політика Конфіденційності',
    termsOfService: 'Умови Використання',
  },

  faq: {
    badge: 'ЧаПи',
    heading: 'Часті Запитання',
    subheading: 'Швидкі відповіді на поширені запитання про ці інструменти.',
    stillHaveQuestions: 'Ще є запитання? Ми залюбки допоможемо!',
    reachOut: 'Зв\'яжіться з Нами',
    questionHeader: 'Запитання',
  },
  contactForm: {
    badge: "Зв'язатись з нами",
    title: 'Напишіть нам',
    subtitle: 'Ми ради отримати ваші повідомлення. Надішліть нам повідомлення!',
    nameLabel: "Ім'я",
    namePlaceholder: "Ваше повне ім'я",
    emailLabel: 'Електронна пошта',
    emailPlaceholder: 'vy@email.ua',
    subjectLabel: 'Тема',
    subjectPlaceholder: 'Про що це?',
    messageLabel: 'Повідомлення',
    messagePlaceholder: 'Напишіть своє повідомлення тут…',
    errName: "Ім'я обов'язкове",
    errEmail: "Ел.пошта обов'язкова",
    errEmailInvalid: 'Введіть дійсну ел.пошту',
    errSubject: "Тема обов'язкова",
    errMessage: "Повідомлення обов'язкове",
    sending: 'Надсилається…',
    send: 'Надіслати повідомлення',
    successTitle: 'Повідомлення надіслано!',
    successMsg: "Дякуємо за зв'язок. Ми відповімо вам незабаром.",
    sendAnother: 'Надіслати ще',
    sendError: 'Щось пішло не так. Спробуйте ще раз.',
  },
  about: {
    label: 'Про Нас',
    heading: 'Створено для Творців Творцями',
    subheading: 'Ми вважаємо, що потужні інструменти для зображень мають бути безкоштовними, швидкими та доступними для всіх.',
    missionTitle: 'Наша Місія',
    missionText: 'photremium.com створено з простою метою: забезпечити найінтуїтивніший, найшвидший та найбільш конфіденційний досвід редагування зображень в Інтернеті.',
    privacyTitle: 'Конфіденційність Перш за Все',
    privacyText: 'Ми не завантажуємо, не зберігаємо та не обробляємо ваші зображення дистанційно. Все залишається на вашому пристрої.',
    techTitle: 'Сучасні Технології',
    techText: 'Побудовано з використанням новітніх вебтехнологій, включаючи WebAssembly, Canvas API та сучасний React.',
    communityTitle: 'Орієнтовано на Спільноту',
    communityText: 'Кожна функція натхненна відгуками реальних користувачів.',
    globalTitle: 'Глобальне Охоплення',
    globalText: 'Використовується творцями з більш ніж 120 країн.',
  },

  seo: {
    homeTitle: 'photremium.com — Безкоштовний Онлайн Конвертер, Компресор та Редактор Зображень',
    homeDesc: 'Конвертуйте, стискайте, змінюйте розмір, обрізайте та редагуйте зображення безкоштовно онлайн.',
    homeKeywords: 'конвертер зображень, компресор зображень, змінити розмір, обрізати зображення, фоторедактор',
    aboutTitle: 'Про photremium.com — Наша Місія',
    aboutDesc: 'Дізнайтеся про photremium.com, безкоштовний онлайн-набір інструментів для зображень, якому довіряють мільйони.',
    aboutKeywords: 'про photremium.com, інструменти зображень, безкоштовний редактор зображень',
  },

      privacyPolicyPage: {
    seo: {
      title: 'Політика конфіденційності — Photremium | Немає завантажень на сервер, нульове зберігання даних',
      description: 'Політика конфіденційності Photremium пояснює, як ми захищаємо вашу конфіденційність. Уся обробка зображень на 100% відбувається у вашому браузері — файли не завантажуються на будь-який сервер, не збираються особисті дані, не відстежується.',
      ogTitle: 'Політика конфіденційності — Photremium | Немає завантажень, нуль пам’яті',
      ogDescription: 'Ваші файли залишаються на вашому пристрої. Photremium обробляє всі зображення локально у вашому браузері без зв’язку з сервером, без збереження даних і відстеження.',
      twitterTitle: 'Політика конфіденційності — Photremium',
      twitterDescription: '100% браузерні інструменти для зображень. Ні завантажень, ні зберігання, ні відстеження. Прочитайте нашу повну політику конфіденційності.',
      schemaName: 'Політика конфіденційності - Photremium',
      schemaDescription: 'Політика конфіденційності Photremium - жодних завантажень на сервер, жодних даних не зберігається, 100% обробка зображень у браузері.'
    },
    hero: {
      badge: 'Політика конфіденційності',
      titlePrefix: 'Ваша конфіденційність - наша',
      titleHighlight: 'Головний пріоритет',
      subPrefix: 'photremium.com побудований на простому принципі —',
      subStrong: 'ваші файли ніколи не залишають ваш пристрій',
      subSuffix: 'Усі інструменти для зображень на цьому сайті повністю працюють у вашому браузері. Немає завантажень. Без хмари. Жодного компромісу.',
      effectiveLabel: 'Ефективний',
      lastUpdatedLabel: 'Останнє оновлення',
      worldwideLabel: 'Застосовується в усьому світі'
    },
    trustCards: [
      {
        title: 'Немає завантажень на сервер',
        desc: 'Ваші файли ніколи не залишають ваш пристрій. Уся обробка на 100% здійснюється в браузері.'
      },
      {
        title: 'Нульове зберігання даних',
        desc: 'Ми не зберігаємо нічого про вас, ваші зображення чи вашу діяльність.'
      },
      {
        title: 'Без відстеження',
        desc: 'Ні відстеження поведінки, ні відбитків пальців, ні профілювання.'
      },
      {
        title: 'Відповідність GDPR',
        desc: 'Створено з нуля для дотримання глобальних норм конфіденційності.'
      }
    ],
    contentsTitle: 'Зміст',
    toc: {
      overview: 'Огляд',
      'no-upload': 'Немає серверної обробки',
      'data-collect': 'Дані, які ми збираємо',
      cookies: 'Файли cookie та зберігання',
      'third-party': 'Послуги третіх осіб',
      analytics: 'Аналітика',
      children: 'Конфіденційність дітей',
      rights: 'Ваші права',
      security: 'Безпека',
      changes: 'Зміни політики',
      contact: 'Зв\'яжіться з нами'
    },
    sections: {
      overview: {
        title: '1. Огляд',
        subtitle: 'Що покриває ця політика',
        p1Prefix: 'Ця Політика конфіденційності описує, як',
        p1Middle: '("ми", "нас" або "наш") ручки - або точніше,',
        p1Italic: 'не справляється',
        p1Suffix: 'вашу особисту інформацію, коли ви використовуєте наші безкоштовні онлайн-інструменти для зображень на',
        p2: 'На відміну від традиційних веб-додатків, які надсилають файли на віддалені сервери для обробки, photremium.com використовує сучасні API браузера (API Canvas, WebAssembly, WebWorkers) для виконання кожної операції локально на вашому пристрої. Результат: без передачі даних, без зберігання, без ризику.',
        calloutLabel: 'Резюме простим англійською мовою:',
        calloutText: 'Ми не можемо бачити ваші зображення, ми не хочемо, і наша технологія спеціально розроблена, щоб ми ніколи не могли.'
      },
      noUpload: {
        title: '2. Відсутність серверної обробки — ніколи',
        subtitle: 'Як насправді працюють наші інструменти',
        introPrefix: 'Усі інструменти на photremium.com — конвертер зображень, компресор, засіб зміни розміру, видалення фону, розмиття обличчя, водяний знак, кадрування та QR-код — обробляють ваші файли',
        introStrong: '100% у вашому веб-браузері',
        introSuffix: 'за допомогою клієнтського JavaScript і WebAssembly.',
        points: [
          {
            label: 'Ніколи не відбувається завантаження файлів.',
            text: 'Коли ви вибираєте файл, він зчитується File API вашого браузера та обробляється в пам’яті — він ніколи не надсилається через мережу.'
          },
          {
            label: 'Жоден сервер не отримує ваше зображення.',
            text: 'Наш CDN обслуговує лише ресурси HTML, CSS і JavaScript, необхідні для запуску програми, а не ваші файли.'
          },
          {
            label: 'Без тимчасового зберігання.',
            text: 'Оброблені результати існують лише в пам’яті вашого браузера та звільняються, коли ви закриваєте сторінку або переходите з неї.'
          },
          {
            label: 'Працює офлайн.',
            text: 'Більшість інструментів продовжують працювати без підключення до Інтернету після початкового завантаження сторінки — ще один доказ, що сервер не задіяний.'
          }
        ],
        callout: 'Ви можете переконатися в цьому самостійно: відкрийте вкладку «Мережа» у веб-переглядачі в «Інструментах розробника», виберіть зображення та переконайтеся, що файли не передаються на зовнішній сервер.'
      },
      dataCollect: {
        title: '3. Дані, які ми збираємо (і не збираємо)',
        subtitle: 'Повна прозорість практики обробки даних',
        headers: {
          type: 'Тип даних',
          collected: 'Зібрано?',
          whereWhy: 'Де / Чому'
        },
        rows: [
          {
            type: 'Ваші зображення / файли',
            badge: 'Ніколи',
            variant: 'зелений',
            showX: true,
            whereWhy: 'Обробляється повністю у вашому браузері — ніколи не передається'
          },
          {
            type: 'Ім\'я / адреса електронної пошти',
            badge: 'Ніколи',
            variant: 'зелений',
            showX: true,
            whereWhy: 'Для використання будь-якого інструменту не потрібно обліковий запис або реєстрація'
          },
          {
            type: 'IP адреса',
            badge: 'Мінімальний',
            variant: 'сірий',
            showX: false,
            whereWhy: 'Стандартні журнали веб-сервера зберігаються <= 30 днів, не прив’язані до ідентичності'
          },
          {
            type: 'Тип браузера/ОС',
            badge: 'Мінімальний',
            variant: 'сірий',
            showX: false,
            whereWhy: 'Надсилається вашим браузером автоматично; використовується тільки для сумісності'
          },
          {
            type: 'Відвідані сторінки / кліки',
            badge: 'Агрегований',
            variant: 'блакитний',
            showX: false,
            whereWhy: 'Лише анонімна аналітика (без ідентифікації особи)'
          },
          {
            type: 'Налаштування мови',
            badge: 'Тільки місцеві',
            variant: 'блакитний',
            showX: false,
            whereWhy: 'Збережено в localStorage на вашому пристрої — ніколи не надсилалося нам'
          },
          {
            type: 'Платіжні / фінансові дані',
            badge: 'Ніколи',
            variant: 'зелений',
            showX: true,
            whereWhy: 'photremium.com абсолютно безкоштовний і не вимагає жодних платежів'
          }
        ]
      },
      cookies: {
        title: '4. Файли cookie та локальне сховище',
        subtitle: 'Що зберігається на вашому пристрої',
        intro: 'photremium.com не використовує рекламні файли cookie, файли cookie міжсайтового відстеження та файли cookie третіх сторін. Єдине сховище браузера, яке ми використовуємо, призначене для основних функцій сайту.',
        points: [
          {
            label: 'Налаштування мови',
            text: 'Зберігається в localStorage, щоб сайт запам’ятовував вашу бажану мову між відвідуваннями. Ніколи не надсилалося на наші сервери.'
          },
          {
            label: 'Параметри теми/інтерфейсу',
            text: 'Якщо ви встановлюєте параметри відображення, вони зберігаються локально лише на вашому пристрої.'
          },
          {
            label: 'Немає файлів cookie сесії.',
            text: 'photremium.com не має системи входу, тому файли cookie ідентифікатора сеансу ніколи не записуються.'
          }
        ],
        callout: 'Ви можете будь-коли очистити все локальне сховище photremium.com у налаштуваннях браузера (Налаштування -> Конфіденційність -> Очистити дані веб-перегляду -> Кешовані дані та файли cookie). Це не вплине на вашу здатність користуватися інструментами.'
      },
      thirdParty: {
        title: '5. Послуги третіх сторін',
        subtitle: 'Зовнішні сервіси, якими ми користуємося, і чому',
        intro: 'photremium.com використовує мінімальний набір надійних сторонніх служб виключно для інфраструктури та продуктивності. Жодна з цих служб не отримує ваші зображення чи будь-яку особисту інформацію.',
        headers: {
          service: 'Сервіс',
          purpose: 'призначення',
          dataShared: 'Спільні дані',
          privacyPolicy: 'Політика конфіденційності'
        },
        rows: [
          {
            service: 'Сторінки Cloudflare',
            purpose: 'Хостинг і CDN доставка активів сайту',
            dataShared: 'IP-адреса, заголовки HTTP (стандартні)',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: 'Шрифт Awesome',
            purpose: 'Шрифти значків, завантажені з CDN',
            dataShared: 'IP-адреса (лише запит CSS)',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: 'Шрифти Google',
            purpose: 'Завантаження гарнітури (за наявності)',
            dataShared: 'IP-адреса (лише запит шрифту)',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: 'Ми не надаємо ваші дані рекламодавцям, брокерам даних або будь-якій іншій третій стороні, окрім постачальників інфраструктури, перелічених вище.'
      },
      analytics: {
        title: '6. Аналітика',
        subtitle: 'Зведені дані про використання з дотриманням конфіденційності',
        introPrefix: 'Щоб зрозуміти, які інструменти популярні та як покращити сайт, ми можемо зібрати',
        introStrong: 'агрегований, анонімний',
        introSuffix: 'статистика використання, наприклад:',
        points: [
          'Кількість переглядів сторінок на інструмент (без ідентифікації користувача)',
          'Джерело рефералу (наприклад, пошук Google, пряме посилання) — особистих даних немає',
          'Географічні дані на рівні країни (не місто чи точне місцезнаходження)',
          'Браузер/тип пристрою для аналізу сумісності'
        ],
        calloutLabel: 'Жодні дані не пов’язані з вами особисто.',
        calloutText: 'Ми не використовуємо Google Analytics або Meta Pixel. Будь-яка аналітика, яку ми використовуємо, є інструментом, який надає перевагу конфіденційності (наприклад, Plausible або подібний).'
      },
      children: {
        title: '7. Конфіденційність дітей',
        subtitle: 'COPPA та дотримання правил безпеки дітей',
        p1: 'photremium.com свідомо не збирає будь-яку особисту інформацію від дітей віком до 13 років (або 16 у Європейському Союзі відповідно до GDPR). Оскільки ми не збираємо персональні дані від жодного користувача, молодим користувачам нічого особливого робити — сайт однаково безпечний для всіх.',
        p2Prefix: 'Якщо ви вважаєте, що дитина якимось чином надіслала особисту інформацію через нашу контактну форму, негайно зв’яжіться з нами за адресою',
        p2Suffix: 'і ми негайно видалимо його.'
      },
      rights: {
        title: '8. Ваші права',
        subtitle: 'GDPR, CCPA та глобальні права на конфіденційність',
        intro: 'Оскільки photremium.com не збирає особисту інформацію, більшість прав суб’єктів даних застосовуються тривіально — немає даних про вас, до яких можна отримати доступ, виправити чи видалити. Тим не менш, ми повністю визнаємо та поважаємо такі права:',
        points: [
          {
            label: 'Право доступу',
            text: 'Ви можете запросити копію будь-яких даних про вас, які ми зберігаємо. (Немає нічого, крім анонімних журналів.)'
          },
          {
            label: 'Право на виправлення',
            text: 'Ви можете вимагати виправлення неточних персональних даних.'
          },
          {
            label: 'Право на видалення («Право бути забутим»)',
            text: 'Ви можете вимагати видалення будь-яких персональних даних, які ми зберігаємо (GDPR, ст. 17, CCPA).'
          },
          {
            label: 'Право на заперечення / відмову',
            text: 'Ви можете відмовитися від будь-якої майбутньої колекції аналітики за допомогою інструмента відмови на рівні веб-переглядача або блокування реклами.'
          },
          {
            label: 'Право на перенесення даних',
            text: 'Уся ваша робота завантажується безпосередньо на ваш пристрій — запит на експорт не потрібен.'
          }
        ],
        callout: 'Ці права поширюються на всіх користувачів у всьому світі незалежно від юрисдикції — ми застосовуємо найвищі стандарти (GDPR) як нашу базову лінію.'
      },
      security: {
        title: '9. Безпека',
        subtitle: 'Як ми захищаємо ваш досвід',
        intro: 'Найбільш безпечні дані – це дані, які ніколи не збираються. Клієнтська архітектура photremium.com означає, що порушення роботи сервера не може розкрити ваші файли, оскільки вони ніколи не знаходяться на наших серверах. Додаткові заходи безпеки включають:',
        points: [
          {
            label: 'Застосування HTTPS',
            text: 'Весь трафік між вашим браузером і нашим CDN шифрується за допомогою TLS 1.2+ із HSTS.'
          },
          {
            label: 'Політика безпеки вмісту (CSP)',
            text: 'Строгі заголовки запобігають міжсайтовому сценарію та вбудованому сценарію.'
          },
          {
            label: 'Регулярні аудити залежностей',
            text: 'Ми регулярно перевіряємо та оновлюємо пакети npm, щоб виправити відомі вразливості.'
          }
        ],
        disclosurePrefix: 'Відповідальне розголошення',
        disclosureTextPrefix: 'Знайшли проблему безпеки? Пишіть нам на адресу',
        disclosureTextSuffix: 'і ми відповімо протягом 48 годин.'
      },
      changes: {
        title: '10. Зміни до цієї Політики',
        subtitle: 'Як ми обробляємо оновлення політики',
        intro: 'Ми можемо час від часу оновлювати цю Політику конфіденційності, щоб відобразити зміни в наших методах, інструментах або правових вимогах. Коли ми робимо:',
        points: [
          {
            label: '"Останнє оновлення"',
            text: 'дата вгорі цієї сторінки буде переглянута.'
          },
          {
            label: 'Матеріальні зміни',
            text: 'буде повідомлено через помітне повідомлення на домашній сторінці протягом принаймні 30 днів.'
          },
          {
            label: 'Попередні версії',
            text: 'цієї політики буде заархівовано та доступно за запитом.'
          }
        ],
        outro: 'Продовження використання photremium.com після публікації змін означає згоду з оновленою політикою. Ми радимо вам періодично переглядати цю сторінку.'
      },
      contact: {
        title: '11. Запити на контакти та дані',
        subtitle: 'Звертайтесь щодо конфіденційності',
        p1Prefix: 'З будь-якими запитаннями, занепокоєннями або офіційними запитами даних, пов’язаними з цією Політикою конфіденційності, зв’яжіться з нами. Ми прагнемо відповідати на всі запити, пов’язані з конфіденційністю',
        p1Strong: '5 робочих днів'
      }
    },
    footer: {
      privacyQuestionsTitle: 'Запитання щодо конфіденційності?',
      privacyQuestionsDesc: 'Надішліть нам свої запитання щодо конфіденційності, запити щодо даних або проблеми, і ми швидко відповімо.',
      versionHistoryTitle: 'Історія версій',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
common: {
    new: 'Нове!',
    download: 'Завантажити',
    downloadAll: 'Завантажити Все',
    downloadAs: 'Завантажити як:',
    zip: 'ZIP',
    separate: 'Окремо',
    upload: 'Завантажити',
    dragDrop: 'Перетягніть зображення сюди або натисніть для перегляду',
    remove: 'Видалити',
    reset: 'Скинути',
    apply: 'Застосувати',
    cancel: 'Скасувати',
    clear: 'Очистити',
    close: 'Закрити',
    save: 'Зберегти',
    processing: 'Обробка...',
    noFiles: 'Файл не вибрано',
    selectFiles: 'Вибрати Файли',
    or: 'або',
    browseFiles: 'Переглянути Файли',
    dropHere: 'Перетягніть зображення сюди',
    chooseFiles: 'Вибрати Файли',
    pasteHint: 'Ви також можете вставити зображення',
    quality: 'Якість',
    width: 'Ширина',
    height: 'Висота',
    format: 'Формат',
    compression: 'Стиснення',
    preview: 'Попередній Перегляд',
    original: 'Оригінал',
    result: 'Результат',
    before: 'До',
    after: 'Після',
    startOver: 'Почати Заново',
    startOverConfirm: 'Видалити всі зображення та почати заново?',
    addMoreImages: 'Додати Більше Зображень',
    addImage: 'Додати Зображення',
    images: 'зображень',
    totalSize: 'Загальний Розмір',
    size: 'Розмір',
    type: 'Тип',
    unsavedEdits: 'Ви маєте незбережені зміни. Покинути цю сторінку?',
    compareSlider: 'Повзунок Порівняння',
    toggleToolsPanel: 'Перемкнути Панель Інструментів',
    closePanel: 'Закрити Панель',
    zoomIn: 'Збільшити',
    zoomOut: 'Зменшити',
    fit: 'Підігнати',
    none: 'Немає',
  },

  compressor: {
    seo: {
      uploadTitle: 'Компресор Зображень — Стискайте JPG, PNG, SVG, GIF Безкоштовно | photremium.com',
      uploadDesc: 'Стискайте зображення JPG, PNG, SVG та GIF безкоштовно онлайн. Зменшіть розмір файлу до 80% зі збереженням якості.',
      uploadKeywords: 'компресор зображень, стиснення jpg, стиснення png, зменшити розмір зображення',
      workspaceTitle: 'Стиснення Зображень — photremium.com',
      workspaceDesc: 'Налаштуйте рівень стиснення та завантажте оптимізовані зображення.',
      workspaceKeywords: 'стиснення зображень, оптимізація зображень',
    },
    title: 'Компресор Зображень',
    desc: 'Стискайте зображення JPG, PNG та GIF до 80%. Швидко та безпечно.',
    toCompress: 'для стиснення',
    compressionForAll: 'Стиснення для всіх зображень',
    summary: 'Підсумок',
    originalSize: 'Оригінальний Розмір',
    compressed: 'Стиснено',
    saved: 'Заощаджено',
    compressionLabel: 'Стиснення:',
    compressing: 'Стиснення…',
    compressDownload: 'Стиснути та Завантажити',
    lowQualityWarning: 'Високе стиснення може помітно знизити чіткість зображення.',
    blog: {
      tocTitle: 'Зміст',
      title: 'Блог про стискання зображень',
      formatsIntro: 'Наш інструмент підтримує всі формати зображень, тож ви можете легко стискати будь-яке зображення. Повний список форматів наведено нижче:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. Що таке компресор зображень?',
          paragraphs: [
            'Компресор зображень — це програма або онлайн-сервіс, що зменшує розмір файлу зображення зі збереженням візуальної якості. Однак надмірне стиснення може помітно погіршити якість.',
          ],
          listTitle: 'ТИПИ:',
          bullets: [
            'Стискання з втратами: розмір зображення зменшується шляхом видалення частини даних. Якість може знизитися, але за помірного рівня це часто майже непомітно.',
            'Стискання без втрат: зменшує розмір файлу без впливу на візуальну якість зображення.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. Чому варто обрати наш інструмент?',
          bullets: [
            'Наш AI-інструмент для стискання зображень працює плавно на всіх пристроях і дає найкращі результати.',
            'Ви можете стискати багато зображень одночасно (навіть 100+) одним кліком.',
            'Не потрібно завантажувати зображення на сервер — усе обробляється локально у вашому браузері.',
            'Наш інструмент повністю безкоштовний назавжди, і ви можете поділитися ним із друзями.',
            'Ви можете вибрати відсоток стискання відповідно до своїх потреб.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Покрокова інструкція',
          steps: [
            {
              heading: '1. Виберіть зображення, яке хочете стиснути.',
              bullets: [
                'Перетягніть зображення в область завантаження.',
                'Також можна скопіювати зображення та вставити в поле за допомогою (Ctrl + V).',
                'Підтримується і вибір через файловий провідник кнопкою вибору.',
              ],
            },
            {
              heading: '2. Потім виберіть відсоток стискання.',
              bullets: [
                'Горизонтальний повзунок дозволяє зручно обрати рівень стискання. Для точнішого результату орієнтуйтесь на діапазони нижче.',
              ],
              table: {
                headers: ['Відсоток стискання', 'Результат'],
                rows: [
                  ['1%  до  40%', 'Найкраща якість'],
                  ['41%  до  60%', 'Нормальна якість (Рекомендовано)'],
                  ['61%  до  100%', 'Низька якість'],
                ],
              },
            },
            {
              heading: '3. Перевірте, скільки памʼяті ви заощадили.',
              paragraphs: [
                'Усі показники розміру відображаються в реальному часі. Ви чітко бачите, скільки місця заощаджено, і можете налаштувати стискання під потрібний розмір файлу.',
              ],
            },
            {
              heading: '4. Виберіть спосіб завантаження перемикачем.',
              bullets: [
                'ZIP: якщо стискаєте кілька зображень, зʼявиться ця опція. Усі стиснені файли буде зібрано в один ZIP (рекомендовано для великої кількості зображень).',
                'Окремо: кожне зображення буде завантажено окремо, а не одним ZIP-файлом (рекомендовано для невеликої кількості — менше 10).',
              ],
            },
            {
              heading: '5. Стисніть і завантажте зображення.',
              paragraphs: [
                'Ця кнопка автоматично завантажить усі стиснені зображення відповідно до обраного способу завантаження.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Переваги компресора зображень.',
          bullets: [
            'Менші витрати на зберігання: стискання значно зменшує розмір файлів.',
            'Швидше завантаження: стиснені зображення відкриваються швидше, покращуючи досвід користувача.',
            'Рішення для обмеження Gmail: оскільки Gmail обмежує вкладення до 25MB, стискання дозволяє надсилати більше файлів.',
            'Швидше поширення та передавання: великі файли передаються довше; стискання економить час і трафік.',
            'Оптимізація презентацій: не стиснені зображення роблять файл презентації важким, а стиснені суттєво зменшують розмір.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Підтримувані формати.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'Конвертер Зображень — Конвертуйте PNG, JPG, WEBP, GIF, SVG Безкоштовно | photremium.com',
      uploadDesc: 'Конвертуйте зображення між JPG, PNG, WEBP, GIF, SVG, TIFF та BMP. Безкоштовний онлайн конвертер форматів.',
      uploadKeywords: 'конвертер зображень, png в jpg, jpg в png, конвертер webp',
      workspaceKeywords: 'конвертація зображень, конвертер форматів зображень',

      routeKeywords: {

        'png-to-jpg': 'png для конвертації jpg, png to jpg, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'jpg-to-png': 'jpg для конвертації png, jpg to png, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'png-to-webp': 'png для конвертації webp, png to webp, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'jpg-to-webp': 'jpg для конвертації webp, jpg to webp, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'webp-to-jpg': 'webp для конвертації jpg, webp to jpg, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'webp-to-png': 'webp для конвертації png, webp to png, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'gif-to-jpg': 'gif для конвертації jpg, gif to jpg, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'gif-to-png': 'gif для конвертації png, gif to png, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'bmp-to-jpg': 'bmp для конвертації jpg, bmp to jpg, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'bmp-to-png': 'bmp для конвертації png, bmp to png, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'svg-to-png': 'svg для конвертації png, svg to png, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'svg-to-jpg': 'svg для конвертації jpg, svg to jpg, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'tiff-to-jpg': 'tiff для конвертації jpg, tiff to jpg, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'tiff-to-png': 'tiff для конвертації png, tiff to png, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'jpg-to-gif': 'jpg для конвертації gif, jpg to gif, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'png-to-gif': 'png для конвертації gif, png to gif, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'jpg-to-bmp': 'jpg для конвертації bmp, jpg to bmp, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'png-to-bmp': 'png для конвертації bmp, png to bmp, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'webp-to-gif': 'webp для конвертації gif, webp to gif, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'jpg-to-ico': 'jpg для конвертації ico, jpg to ico, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'png-to-ico': 'png для конвертації ico, png to ico, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'jpg-to-svg': 'jpg для конвертації svg, jpg to svg, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'png-to-svg': 'png для конвертації svg, png to svg, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'webp-to-svg': 'webp для конвертації svg, webp to svg, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'gif-to-svg': 'gif для конвертації svg, gif to svg, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'bmp-to-svg': 'bmp для конвертації svg, bmp to svg, конвертер зображень, png в jpg, jpg в png, конвертер webp',

        'tiff-to-svg': 'tiff для конвертації svg, tiff to svg, конвертер зображень, png в jpg, jpg в png, конвертер webp',

      },
    },
    title: 'Конвертер Зображень',
    desc: 'Конвертуйте зображення між JPG, PNG, WEBP, GIF, SVG, TIFF та BMP. Пакетна конвертація.',
    toConvert: 'для конвертації',
    convertSettings: 'Налаштування Конвертації',
    detected: 'Виявлено',
    convertTo: 'Конвертувати в',
    converting: 'Конвертація…',
    convertToFormat: 'Конвертувати у {format}',
    popularConversions: 'Популярні Конвертації',
    convertingTo: 'Конвертація в',
    all: 'Всі',
  },

  resizer: {
    seo: {
      uploadTitle: 'Змінити Розмір Зображення — JPG, PNG Безкоштовно | photremium.com',
      uploadDesc: 'Змінюйте розмір зображень у пікселях або відсотках безкоштовно онлайн.',
      uploadKeywords: 'змінити розмір зображення, інструмент зміни розміру, jpg розмір, png розмір',
      workspaceTitle: 'Зміна Розміру Зображення — photremium.com',
      workspaceDesc: 'Змінюйте розмір зображень безкоштовно онлайн.',
      workspaceKeywords: 'змінити розмір зображення, зміна розміру',
    },
    title: 'Змінити Розмір Зображення',
    desc: 'Вкажіть розмір у пікселях, відсотках, сантиметрах або дюймах та миттєво змініть розмір.',
    toResize: 'для зміни розміру',
    resizeSettings: 'Налаштування Розміру',
    resizeBy: 'Змінити розмір за:',
    byPixels: 'Пікселі',
    byPercentage: 'Відсотки',
    byCentimeters: 'Сантиметри',
    byInches: 'Дюйми',
    advanced: 'Розширені',
    lockAspect: 'Зафіксувати Пропорції',
    unlockAspect: 'Розфіксувати Пропорції',
    dontEnlarge: 'Не збільшувати, якщо оригінал менший',
    resizing: 'Зміна розміру…',
    resizeDownload: 'Змінити Розмір та Завантажити',
    blog: {
      tocTitle: 'Зміст',
      title: 'Блог про зміну розміру зображень',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. Чому варто використовувати інструмент зміни розміру зображень?',
          paragraphs: [
            'Інструмент зміни розміру зображень — це засіб/програма для зміни розмірів зображення. Ви можете налаштувати висоту, ширину або обидва параметри, щоб отримати потрібний розмір. Це особливо корисно для соціальних платформ, де є обмеження на розміри зображень для публікації.',
          ],
          listTitle: 'Наприклад:',
          bullets: [
            'Публікація в Instagram: 1080 x 1080px (квадрат)',
            'Публікація у Facebook: 1200 x 630px',
            'Публікація в X (Twitter): 1200 x 675px',
            'Історія Instagram: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. Чому обрати наш інструмент зміни розміру?',
          paragraphs: [
            'Наш AI-інструмент дозволяє змінювати розмір зображень точно та дуже швидко. Він стабільно працює на будь-якому пристрої й не потребує встановлення застосунку. Усі функції доступні онлайн прямо в браузері.',
          ],
          bullets: [
            'Ви можете змінювати розмір одразу багатьох зображень (навіть 100+). На продуктивних пристроях можлива обробка 400–500 зображень за кілька секунд.',
            'Уся обробка виконується локально в браузері. Завантажувати зображення на сервер не потрібно, файли не залишають ваш пристрій.',
            'Підтримуються різні одиниці зміни розміру.',
            'Можна зберегти пропорції зображення одним прапорцем.',
            'Для багатьох зображень доступне окреме завантаження або одним ZIP-архівом.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Покрокова інструкція',
          steps: [
            {
              heading: 'Спочатку виберіть зображення (одне або кілька), розмір яких потрібно змінити. Є кілька способів вибору.',
              bullets: [
                'Перетягніть зображення у поле завантаження.',
                'Або вставте зображення за допомогою “Ctrl + V”.',
                'Або натисніть “Choose Files”, щоб вибрати через файловий провідник.',
              ],
            },
            {
              heading: 'Далі виберіть одиницю зміни розміру. Наразі доступні:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'Після вибору одиниці налаштуйте висоту та ширину. За потреби зафіксуйте пропорції прапорцем.',
            },
            {
              heading: 'Якщо не хочете збільшувати зображення більше за оригінал, увімкніть “Don’t enlarge if original is smaller”.',
            },
            {
              heading: 'Потім виберіть спосіб завантаження.',
              bullets: [
                'Оберіть ZIP, якщо хочете завантажити всі змінені зображення одним zip-файлом.',
                'Оберіть “separate”, якщо хочете завантажувати кожне зображення окремо.',
              ],
            },
            {
              heading: 'Наостанок натисніть “Resize & Download”, щоб завантажити згідно з обраним варіантом.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Переваги інструмента зміни розміру: головна перевага — правильне розміщення зображень на вебсторінках і в дописах соцмереж.',
          tocLabel: '4. Переваги інструмента зміни розміру',
          bullets: [
            'Покращення UX: правильний розмір і розташування зображень значно покращують досвід користувача.',
            'Підтримка соцмереж: багато платформ мають обмеження розмірів, і інструмент допомагає їм відповідати.',
            'Адаптивний дизайн: розробникам потрібні різні розміри зображень для різних пристроїв.',
            'Кращий вибір: замість розтягування чи жорсткого обрізання зображення зміна розміру зазвичай дає кращий результат.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Підтримувані формати: наш інструмент підтримує вибір зображень будь-якого формату. Список підтримуваних форматів:',
          tocLabel: '5. Підтримувані формати',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'Обрізати Зображення — JPG, PNG, GIF Безкоштовно | photremium.com',
      uploadDesc: 'Легко обрізайте зображення JPG, PNG та GIF безкоштовно онлайн.',
      uploadKeywords: 'обрізати зображення, інструмент обрізки, обрізати jpg, обрізати png',
      workspaceTitle: 'Обрізка Зображення — photremium.com',
      workspaceDesc: 'Обрізайте зображення безкоштовно онлайн.',
      workspaceKeywords: 'обрізати зображення, обрізка',
    },
    title: 'Обрізати Зображення',
    desc: 'Обрізайте JPG, PNG, GIF та інші за допомогою візуального редактора. Попередньо встановлені або вільні пропорції.',
    toCrop: 'для обрізки',
    cropSettings: 'Налаштування Обрізки',
    widthPx: 'Ширина (px)',
    heightPx: 'Висота (px)',
    positionX: 'Позиція X (px)',
    positionY: 'Позиція Y (px)',
    cropTemplate: 'Шаблон Обрізки',
    landscape: 'Горизонтальний',
    portrait: 'Вертикальний',
    square: 'Квадрат',
    freeform: 'Вільний',
    cropping: 'Обрізка…',
    cropDownload: 'Обрізати та Завантажити',
    cropDownloadAll: 'Обрізати та Завантажити Всі',
    saveNext: 'Зберегти та Наступне',
    croppedNofTotal: 'Обрізано {n} з {total}.',
    downloadN: 'Завантажити {n}',
    blog: {
      tocTitle: 'Зміст',
      title: 'Блог про Обрізання Зображень',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. Чому варто використовувати інструмент обрізання зображень?',
          paragraphs: [
            'Інструмент обрізання зображень — це програмний засіб, який використовується для обрізання зображення до потрібної форми. Його широко застосовують, щоб залишити потрібну частину зображення та прибрати зовнішні небажані області для будь-якої мети. Інструмент надає рамку обрізання, яку можна налаштувати в потрібній позиції.',
          ],
          listTitle: 'Наприклад:',
          bullets: [
            'Обрізати себе з групового фото.',
            'Обрізати своє ім’я зі списку.',
            'Обрізати індикатор прогресу з повноекранного скриншота.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. Чому обрати наш інструмент обрізання зображень?',
          paragraphs: [
            'Наш інструмент обрізання зображень дозволяє обрізати зображення точно та дуже швидко. Вам потрібно лише налаштувати розмір рамки обрізання в позиції, яку хочете вирізати з будь-якого зображення. Під час вибору підтримуються майже всі формати зображень.',
          ],
          bullets: [
            'Ви можете обрізати стільки зображень, скільки підтримує ваш пристрій. Якщо у вас продуктивний пристрій, ви навіть можете обрізати 100+ зображень одночасно без лагів та інших проблем.',
            'Ваші зображення обробляються у локальному браузері. Не потрібно завантажувати зображення на наш сервер, тож жодне зображення не залишає ваш пристрій. Ви можете обрізати приватні зображення без ризиків безпеки.',
            'Багато інструментів показують помилку недійсного формату зображення. Наш інструмент вирішує цю проблему, підтримуючи майже всі формати зображень.',
            'Якщо ви обрізаєте багато зображень одночасно, наш інструмент дозволяє завантажити обрізані зображення у ZIP або окремими файлами — за вашим вибором.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Покрокова інструкція',
          steps: [
            {
              heading: '1. Спочатку виберіть зображення, яке хочете обрізати. Наш інструмент також підтримує вибір кількох зображень одночасно.',
              bullets: [
                'Перетягніть зображення в поле завантаження, щоб обрізати їх.',
                'Також ви можете вибрати зображення через провідник файлів, натиснувши кнопку choose files у блоці обрізання.',
                'Також підтримується комбінація Ctrl + V для вставки зображень у поле завантаження.',
              ],
            },
            {
              heading: '2. Потім налаштуйте розмір і позицію рамки обрізання на зображенні.',
            },
            {
              heading: '3. Ви також можете налаштувати рамку вручну, ввівши висоту, ширину, горизонтальну та вертикальну позиції.',
            },
            {
              heading: '4. Ви також можете скористатися кількома готовими шаблонами:',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. Після цього потрібно обрати один із варіантів завантаження.',
              bullets: [
                'ZIP: Оберіть цей варіант, якщо обрізаєте багато зображень і хочете завантажити всі обрізані зображення одним файлом.',
                'Separate: Якщо хочете завантажити всі обрізані зображення окремо, оберіть цей варіант у перемикачі.',
              ],
            },
            {
              heading: '6. Потім натисніть кнопку Crop & Download, щоб завантажити всі обрізані зображення відповідно до ваших заданих розмірів.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Переваги обрізання зображень: інструмент обрізання зображень має низку переваг у цифровому світі. Деякі з них наведені нижче:',
          tocLabel: '4. Переваги обрізання зображень',
          bullets: [
            'Підгонка зображення в рамку: інструмент обрізання допомагає правильно розмістити зображення в рамці. Така рамка може бути на вебсторінці або в соцмережі.',
            'Покращення UX: оскільки правильне розміщення зображень покращує користувацький досвід, обрізання суттєво покращує UX.',
            'Видалення небажаних полів: ви можете прибрати небажані поля з зображення, щоб зробити його охайнішим.',
            'Виділення потрібного об’єкта: ви також можете виділити себе з групового фото.',
            'Економія сховища: обрізання дійсно економить сховище, бо зайва область видаляється, і залишається лише потрібна частина.',
            'Оптимізація презентацій: якщо звичайна презентація з 10 необрізаними зображеннями займає близько 30MB, та сама презентація з обрізаними зображеннями може займати близько 10MB.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Підтримувані формати:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'Онлайн Фоторедактор — Безкоштовне Редагування з Текстом, Ефектами, Рамками | photremium.com',
      desc: 'Редагуйте фотографії онлайн безкоштовно — додавайте текст, ефекти, рамки, стікери. Працює у браузері.',
      keywords: 'фоторедактор, онлайн фоторедактор, редагувати фото онлайн безкоштовно',
    },
    title: 'Фоторедактор',
    desc: 'Прикрашайте свої фотографії текстом, ефектами, рамками та стікерами.',
    toEdit: 'для редагування',
    textTypography: 'Текст та Типографіка',
    textTypographyDesc: 'Додавайте текст з різними шрифтами, кольорами, тінями та параметрами позиціонування.',
    filtersEffects: 'Фільтри та Ефекти',
    filtersEffectsDesc: 'Застосовуйте професійні фільтри та налаштовуйте яскравість, контраст і насиченість.',
    framesStickers: 'Рамки та Стікери',
    framesStickersDesc: 'Вибирайте красиві рамки та веселі стікери для прикраси зображень.',
  },

  removeBg: {
    seo: {
      uploadTitle: 'Безкоштовне Видалення Фону Зображення | photremium.com',
      uploadDesc: 'Швидко видаляйте фон зображення з високою точністю. Безкоштовний онлайн-інструмент.',
      uploadKeywords: 'видалити фон, видалення фону, прозорий фон',
      workspaceTitle: 'Видалення Фону — photremium.com',
      workspaceDesc: 'Видаляйте фон зображення безкоштовно онлайн.',
      workspaceKeywords: 'видалити фон, прозорий фон',
    },
    title: 'Видалити Фон',
    desc: 'Миттєво видаляйте фон зображення за допомогою розширеного виявлення країв. 100% безкоштовно, працює у браузері.',
    toRemoveBg: 'для видалення фону',
    backgroundRemover: 'Інструмент Видалення Фону',
    processingProgress: 'Хід Обробки',
    processingNImages: 'Обробка {n} зображень…',
    allNProcessed: 'Усі {n} зображень оброблено!',
    nOfTotalDone: '{n} / {total} готово',
    fileName: 'Ім\'я Файлу',
    dimensions: 'Розміри',
    status: 'Статус',
    statusDone: '✓ Готово',
    statusProcessing: '⏳ Обробка',
    statusError: '✗ Помилка',
    statusPending: '⏸ Очікування',
    badgeDone: 'Готово',
    badgeProcessing: 'Обробка…',
    badgeError: 'Помилка',
    removingBg: 'Видалення фону…',
    retry: 'Повторити',
    downloading: 'Завантаження…',
    nextImage: 'Наступне Зображення',
  },

  watermark: {
    seo: {
      uploadTitle: 'Водяний Знак на Зображенні — Додайте Текст та Логотип Безкоштовно | photremium.com',
      uploadDesc: 'Додавайте текстові або графічні водяні знаки до фотографій за секунди. Безкоштовно та швидко.',
      uploadKeywords: 'водяний знак, додати водяний знак, текстовий водяний знак',
      workspaceTitle: 'Водяний Знак на Зображенні — photremium.com',
      workspaceDesc: 'Додавайте водяні знаки до зображень безкоштовно онлайн.',
      workspaceKeywords: 'водяний знак, додати водяний знак',
    },
    title: 'Водяний Знак на Зображенні',
    desc: 'Додавайте текстові або логотипні водяні знаки до зображень. Налаштовуйте шрифт, прозорість, розмір та позицію.',
    toWatermark: 'для водяного знаку',
    watermarkTools: 'Інструменти Водяного Знаку',
    addText: 'Додати Текст',
    addImage: 'Додати Зображення',
    layersN: 'Шари ({n})',
    noLayers: 'Шари ще не додано',
    textLayer: 'Текстовий Шар',
    imageLayer: 'Шар Зображення',
    watermarkDownloadAll: 'Додати Знак та Завантажити Все',
    watermarkDownload: 'Додати Знак та Завантажити',
    nextImage: 'Наступне Зображення',    selectToEdit: 'Виберіть будь-яке зображення або текст, щоб почати редагування',    bold: 'Жирний',
    italic: 'Курсив',
    underline: 'Підкреслення',
    bgColor: 'Колір Фону',
    textColor: 'Колір Тексту',
    alignLeft: 'Вирівняти по Лівому Краю',
    alignCenter: 'По Центру',
    alignRight: 'Вирівняти по Правому Краю',
    opacity: 'Прозорість',
    stroke: 'Обведення',
    strokeWidth: 'Ширина Обведення',
    strokeColor: 'Колір Обведення',
    tileRepeat: 'Плитка/Повторення',
    tilePattern: 'Паттерн Плитки',
    spacing: 'Відступ',
    snapToCenter: 'Прив\'язати до Центру',
    duplicate: 'Дублювати',
    delete: 'Видалити',
    flipHorizontal: 'Перевернути Горизонтально',
    flipVertical: 'Перевернути Вертикально',
    rotateLeft: 'Повернути вліво',
    rotateRight: 'Повернути вправо',
    cornerRadius: 'Радіус Кута',
    borderStroke: 'Рамка/Обведення',
    borderWidth: 'Ширина Рамки',
    color: 'Колір',
    style: 'Стиль',
    hide: 'Приховати',
    show: 'Показати',
    lock: 'Заблокувати',
    unlock: 'Розблокувати',
    solid: 'Суцільна',
    dashed: 'Пунктирна',
    dotted: 'Точкова',
    double: 'Подвійна',
    tileSingle: 'Одинарна',
    tile2x2: 'Сітка 2×2',
    tile3x3: 'Сітка 3×3',
    removeAllConfirm: 'Видалити всі зображення та водяні знаки?',
    dimMismatch: 'Завантажені зображення мають різні розміри. Для найкращих результатів завантажуйте зображення однакової роздільності.',
    clearBackground: 'Очистити Фон',
    typeHere: 'Введіть тут...',
    linkCorners: 'Зв\'язати Кути',
    separateCorners: 'Розділити Кути',
    blog: {
      tocTitle: 'Зміст',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Огляд інструмента для водяних знаків',
          title: 'Як додати водяний знак до ваших зображень онлайн — повний посібник з інструмента водяних знаків Photremium',
          paragraphs: [
            'Ви щойно завершили редагування красивої фотографії. Можливо, це знімок товару для вашого магазину, портрет із клієнтської сесії або цифрова робота, над якою ви годинами доводили кожну деталь до досконалості. І тепер постає запитання, з яким зрештою стикається кожен творець: як захистити це перед тим, як поділитися?',
            'Найчастіше професіонали приходять до одного рішення — водяного знака, і на це є вагома причина. Правильно розміщений водяний знак діє як постійний підпис вашої роботи, роблячи її відстежуваною, брендованою та значно складнішою для викрадення.',
            'Проблема, з якою стикається більшість людей, проста: доступні онлайн-інструменти або занадто незручні, або заховані за підписками, або створюють настільки важкий водяний знак, що він повністю псує зображення.',
            'Інструмент Watermark Image від Photremium створено, щоб виправити все це. Це повністю браузерний, безкоштовний, безобліковий робочий простір для нанесення водяних знаків, який працює прямо у вашому браузері без завантаження файлів на сервер. Усе залишається локально, усе працює швидко, а рівень творчого контролю не поступається тому, чого ви очікуєте від настільного застосунку. У цьому посібнику ми детально покажемо, як він працює, для кого він створений і як щоразу досягати найкращого результату.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'Що таке водяний знак',
          title: 'Що таке водяний знак і чому це важливо?',
          paragraphs: [
            'Перш ніж занурюватися в сам інструмент, варто зрозуміти, що робить водяний знак і чому так багато фотографів, дизайнерів і творців контенту вважають його обов’язковим.',
            'Водяний знак — це видима накладка, додана до зображення — зазвичай текст, логотип або символ авторського права, — яка ідентифікує творця або власника контенту. На відміну від метаданих (які приховані всередині файлу й можуть бути видалені за секунди), водяний знак візуально вбудовується в саме зображення. Його не можна просто клацнути правою кнопкою і прибрати без помітного погіршення якості зображення.',
          ],
          subSections: [
            {
              title: 'Чому творці використовують водяні знаки',
              paragraphs: [
                'Практичні причини додавання водяних знаків до ваших зображень зводяться до трьох основних питань.',
              ],
              bullets: [
                'Ідентифікація власності. Коли вашу роботу поширюють у соцмережах, на дошках Pinterest або вбудовують у блогові пости, оригінальне авторство часто зникає. Водяний знак гарантує, що ваше ім’я або бренд подорожують разом із зображенням куди б воно не потрапило.',
                'Стримування крадіжок. Більшість випадкових викрадачів зображень шукають шлях найменшого опору. Професійно виглядаючий водяний знак, особливо добре розміщений і трохи прозорий, дає чіткий сигнал: це зображення належить тому, хто дбає про свою роботу.',
                'Захист портфоліо клієнта. Фотографи, які показують попередні версії клієнтам до остаточної оплати, часто використовують водяні знаки, щоб клієнти не використовували прев’ю без оплати рахунку. Непомітний водяний знак робить це без надмірного відволікання під час оцінки.',
              ],
            },
            {
              title: 'Кому варто наносити водяні знаки на свої зображення',
              paragraphs: [
                'Якщо ви належите до будь-якої з наведених нижче категорій, нанесення водяного знака перед публікацією онлайн не є опцією — це необхідність:',
              ],
              bullets: [
                'Фріланс-фотографи, які діляться галереями з клієнтами',
                'Графічні дизайнери, які поширюють зразки портфоліо',
                'Продавці в e-commerce, які показують фото товарів до ліцензійних угод',
                'Цифрові художники, які діляться роботами в соцмережах',
                'Блогери та творці контенту, чиї зображення регулярно використовують повторно',
                'Постачальники стокових фото, які будують впізнаваний бренд',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Панелі робочого простору',
          title: 'Всередині інструмента водяних знаків Photremium: трипанельний робочий простір, створений для реальних робочих процесів',
          paragraphs: [
            'Те, що вирізняє інструмент водяних знаків Photremium серед простих онлайн-водяних знаків, — це його дизайн робочого простору. Замість простого підходу «введіть текст, виберіть позицію, готово» інструмент пропонує трьохпанельний макет, який нагадує професійне дизайнерське ПЗ — але працює повністю у браузері й не потребує встановлення.',
          ],
          subSections: [
            {
              title: 'Ліва панель canvas',
              paragraphs: [
                'Панель canvas займає найбільшу частину екрана й у реальному часі показує, як саме виглядає ваше зображення після застосування водяного знака. Кожна зміна — регулювання прозорості, переміщення текстового шару, зміна розміру логотипа — миттєво відображається на canvas. Кнопки «preview» немає. Те, що ви бачите, — це те, що отримаєте.',
                'Canvas також має вбудовану панель масштабування, яка дозволяє збільшувати зображення для точного вирівнювання й зменшувати його, щоб бачити загальну картину. Функція автоматичного підбору масштабу обчислює найкращий початковий рівень відповідно до розміру екрана, тож навіть зображення високої роздільності відкриваються у зручному робочому масштабі. Напрямні вирівнювання динамічно з’являються, коли ви перетягуєте шар поблизу горизонтального або вертикального центру зображення, фіксуючи водяний знак точно по центру з тією приємною точністю, яку зазвичай дає лише Photoshop.',
              ],
            },
            {
              title: 'Права панель налаштувань',
              paragraphs: [
                'Права панель — це центр керування. Тут ви керуєте шарами водяних знаків, налаштовуєте їхній вигляд і запускаєте фінальний експорт. На desktop вона закріплена праворуч. На мобільних пристроях вона висувається знизу як нижня панель — через плаваючу кнопку із шестернею — тож ніколи не перекриває canvas під час роботи.',
                'У правій панелі ви знайдете менеджер шарів, який перелічує кожен доданий елемент водяного знака. Кожен запис показує тип шару (текст або зображення), його поточну назву або вміст і три швидкі кнопки: перемикач видимості (іконка ока), перемикач блокування, щоб зафіксувати позицію шару, поки ви працюєте з іншими, і кнопку видалення.',
              ],
            },
            {
              title: 'Ліва смуга попереднього перегляду (режим кількох зображень)',
              paragraphs: [
                'Коли ви працюєте з кількома зображеннями одночасно — серією товарних фото або повною портретною сесією — зліва на екрані з’являється вертикальна смуга мініатюр. Це черга зображень, яка показує мініатюрні попередні перегляди кожного завантаженого файлу. Натискання на будь-яку мініатюру миттєво перемикає canvas на це зображення, дозволяючи перевірити, як виглядає водяний знак у різних композиціях без втрати налаштувань шарів.',
                'Смуга також показує розмір кожного файлу в KB або MB разом із міткою формату файлу (JPG, PNG, WEBP), тож ви завжди бачите, з чим працюєте.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Крок за кроком',
          title: 'Крок за кроком: як додати водяний знак до зображення в Photremium',
          paragraphs: [
            'Цей посібник напряму базується на тому, як інструмент працює всередині — від системи завантаження drag-and-drop до рушія рендерингу canvas, який назавжди записує ваш водяний знак на зображення перед завантаженням.',
          ],
          steps: [
            {
              heading: 'Крок 1 — завантажте своє зображення/зображення',
              paragraphsBefore: [
                'Перейдіть на photremium.com/watermark-image. Ви потрапите на екран завантаження з чистою зоною drag-and-drop у центрі сторінки.',
                'Є три способи додати зображення до інструмента:',
              ],
              bullets: [
                'Перетягування. Перетягніть один або кілька графічних файлів із робочого столу прямо в зону скидання. Інструмент підтримує будь-який стандартний формат зображення — JPEG, PNG, WEBP та інші. Коли ви перетягуєте файли над робочим простором, навколо всієї області активується фіолетова рамка з підказкою «Drop images to add for watermarking», тож ви бачите, що скидання зареєстровано.',
                'Натисніть, щоб переглянути. Натисніть кнопку «Choose Files» у зоні скидання, щоб відкрити системний вибір файлів. Ви можете вибрати кілька файлів одночасно за допомогою Ctrl+Click (Windows) або Cmd+Click (Mac).',
                'Вставлення з буфера обміну. Якщо ви скопіювали зображення у буфер — зі скриншота, іншого застосунку або веббраузера — просто натисніть Ctrl+V (або Cmd+V на Mac), перебуваючи на сторінці водяного знака, і зображення завантажиться безпосередньо в робочий простір. Це працює навіть тоді, коли вже завантажено кілька зображень.',
              ],
              paragraphsAfter: [
                'Щойно завантажиться перше зображення, робочий простір переходить з екрана завантаження до повного трьохпанельного редактора, а canvas показує зображення на автоматично обчисленому масштабі, що підходить під екран.',
              ],
            },
            {
              heading: 'Крок 2 — додайте текстовий шар водяного знака',
              paragraphsBefore: [
                'Натисніть фіолетову кнопку «Add Text» у правій панелі. На canvas з’явиться новий текстовий шар із текстом-заповнювачем «Type here...» уже виділеним.',
                'Ви можете почати друкувати одразу. Текст відображається на canvas білим Arial у розмірі за замовчуванням, налаштованому відповідно до розмірів вашого зображення. З верхньої панелі інструментів, яка з’являється, коли текстовий шар виділений, можна налаштувати кожен аспект тексту:',
              ],
              bullets: [
                'Сімейство шрифтів — виберіть із 12 вбудованих шрифтів, зокрема Arial, Georgia, Impact, Brush Script MT, Comic Sans MS та інших',
                'Розмір шрифту — введіть власне значення в пікселях або використовуйте кнопки зміни',
                'Жирний, курсив, підкреслення — увімкніть будь-яку комбінацію цих стилів',
                'Колір тексту — натисніть на зразок кольору, щоб відкрити вибір кольору й обрати будь-який hex-код',
                'Колір фону — додайте кольоровий фон позаду тексту для вигляду ярлика або бейджа',
                'Обвідка — задайте ширину та колір обвідки для максимальної читабельності на світлих і темних зображеннях',
                'Прозорість — від 0% (невидимо) до 100% (повністю непрозоро); більшість водяних знаків мають значення між 30% і 60%',
                'Вирівнювання — вирівняйте текст ліворуч, по центру або праворуч у межах його рамки',
                'Обертання — обертайте текстовий шар під будь-яким кутом із магнітними точками на 0°, 90°, 180° і 270° для швидкого прямого розміщення',
              ],
              paragraphsAfter: [
                'Щоб пересунути текст, клацніть і перетягніть його в будь-яке місце на canvas. Для точного переміщення піксель за пікселем використовуйте стрілки на клавіатурі (утримуйте Shift для кроків по 10 пікселів). Щоб змінити розмір текстового поля, перетягуйте будь-який із восьми маркерів зміни розміру (кути та краї), які з’являються навколо вибраного шару.',
              ],
            },
            {
              heading: 'Крок 3 — додайте шар водяного знака у вигляді зображення (логотип)',
              paragraphsBefore: [
                'Якщо ви хочете використовувати логотип, підпис або будь-яке зображення як водяний знак замість тексту або разом із ним, натисніть синю кнопку «Add Image» у правій панелі. Відкриється ваш файловий вибір, щоб ви могли обрати файл зображення водяного знака з пристрою.',
                'Інструмент автоматично масштабує зображення водяного знака приблизно до 30% ширини canvas, зберігаючи початкове співвідношення сторін, і центрує його на canvas. Після цього ви можете перетягнути його в будь-яку позицію, змінити розмір за кутові маркери (які зберігають співвідношення сторін) або обертати його за допомогою окремого маркера обертання, що з’являється над вибраним шаром.',
                'Для шарів водяного знака зображення правий панельний блок показує додаткові параметри:',
              ],
              bullets: [
                'Прозорість — як і для текстових шарів, ідеально для прозорих PNG-логотипів',
                'Віддзеркалити по горизонталі / по вертикалі — за потреби дзеркально переверніть водяний знак',
                'Ширина рамки, колір рамки та стиль рамки — додайте видиму рамку навколо логотипа',
                'Радіус кутів — заокругліть кути логотипа рівномірно або окремо для кожного кута',
                'Обертання — така сама плавна поведінка, як у текстових шарів',
              ],
            },
            {
              heading: 'Крок 4 — налаштуйте тайлінг (необов’язково)',
              paragraphsBefore: [
                'Одна з найпотужніших функцій інструмента — тайлінг, тобто можливість повторювати ваш водяний знак по всьому зображенню у вигляді сітки. Це особливо корисно, коли ви хочете зробити зображення непридатним для повторної публікації, а не просто брендованим.',
                'Коли шар виділено, знайдіть опцію tile на панелі інструментів. Ви можете встановити:',
              ],
              bullets: [
                'Немає — одне розміщення (за замовчуванням)',
                'Сітка 2×2 — повторює водяний знак у схемі 2 стовпці × 2 рядки',
                'Сітка 3×3 — повторює у сітці 3×3 для щільнішого покриття',
              ],
              paragraphsAfter: [
                'Ви також можете налаштувати інтервал між тайлами, який визначає проміжок між кожною повторюваною копією. Canvas показує напівпрозорі попередні перегляди всіх тайлів, щоб ви могли бачити повну схему покриття перед завантаженням.',
              ],
            },
            {
              heading: 'Крок 5 — використовуйте менеджер шарів для кількох водяних знаків',
              paragraphsBefore: [
                'Ви можете додати скільки завгодно шарів — вільно поєднуючи текстові та графічні водяні знаки. Менеджер шарів у правій панелі показує їх усі. Ви можете:',
              ],
              bullets: [
                'Показувати або приховувати окремі шари за допомогою іконки ока — це зручно для перемикання між різними версіями водяного знака без видалення',
                'Заблокувати шар, щоб уникнути випадкового зміщення під час роботи з іншими шарами',
                'Видалити шар назавжди',
              ],
              paragraphsAfter: [
                'Натискання на будь-який елемент шару в списку одночасно вибирає його на canvas, що дозволяє легко перемикатися між шарами без пошуків по зображенню.',
              ],
            },
            {
              heading: 'Крок 6 — перемикайтеся між кількома зображеннями',
              paragraphsBefore: [
                'Якщо ви завантажили більше ніж одне зображення, використовуйте смугу мініатюр зліва, щоб перемикати активне зображення canvas. Налаштовані вами шари водяного знака застосовуються глобально — вони будуть відрендерені на кожному зображенні вашої партії під час експорту.',
                'Інструмент також виконує перевірку узгодженості роздільної здатності для всієї партії. Якщо ваші зображення мають суттєво різні розміри (понад 5% різниці в ширині або висоті), з’явиться попередження, яке повідомить, що позиція водяного знака може виглядати інакше на різних зображеннях через різницю розмірів. Рушій обробляє це коректно завдяки алгоритму пропорційного перенесення: він обчислює позицію водяного знака як відсоток від розмірів еталонного зображення та застосовує ту саму пропорційну позицію до кожного іншого зображення партії, зберігаючи візуальний задум навіть на різних роздільностях.',
              ],
            },
            {
              heading: 'Крок 7 — встановіть параметри завантаження',
              paragraphsBefore: [
                'Для одного зображення натисніть кнопку «Download» під canvas, щоб зберегти зображення з водяним знаком безпосередньо. Назва файлу автоматично стане вашою оригінальною назвою з доданим «-watermarked» перед розширенням. Зображення JPEG експортуються з якістю 0.95 — достатньо високою, щоб на звичайних розмірах перегляду вони були невідрізними від оригіналу. Зображення PNG експортуються як безвтратні PNG.',
                'Для пакетної обробки (кілька зображень) у правій панелі доступні два режими завантаження:',
              ],
              bullets: [
                'ZIP-файл — усі зображення з водяними знаками упаковуються в один ZIP-архів, який завантажується одним кліком. Інструмент динамічно завантажує JSZip для стиснення.',
                'Окремі файли — кожне зображення завантажується як окремий файл із короткою паузою між завантаженнями, щоб уникнути обмежень браузера.',
              ],
            },
            {
              heading: 'Крок 8 — завантажте й перевірте',
              paragraphsBefore: [
                'Після натискання кнопки завантаження (або кнопки «Watermark & Download All» для пакетів) інструмент рендерить кожне зображення на прихованому HTML5 canvas у повній нативній роздільності — не в масштабі попереднього перегляду, який ви бачите на екрані. Це означає, що експортоване зображення має 100% своїх оригінальних піксельних розмірів, а водяний знак намальовано у правильно пропорційному розмірі. Відкрийте завантажений файл і збільште масштаб, щоб переконатися, що розміщення та якість водяного знака відповідають вашим очікуванням.',
                'Якщо щось виглядає не так, просто поверніться до робочого простору — ваші шари все ще там — відкоригуйте й завантажте ще раз.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Поради профі',
          title: 'Поради профі для найкращого результату',
          bullets: [
            'Використовуйте напівпрозорий PNG-логотип для максимально професійного вигляду. Водяний знак із прозорим фоном і прозорістю 40–50% виглядає значно акуратніше, ніж суцільний текст. Експортуйте логотип із вашого дизайнерського інструмента як PNG з альфа-прозорістю перед використанням як графічного шару.',
            'Розміщуйте водяний знак там, де його обрізання знецінює зображення. Правий нижній кут — найпоширеніше місце для водяного знака і найпростіше для обрізання. Для кращого захисту розгляньте розміщення водяного знака на візуально важливій ділянці, наприклад на обличчі, деталі товару або фокусній точці. Опція діагонального тайлу ще складніша для видалення без помітного погіршення зображення.',
            'Використовуйте блокування, коли працюєте з кількома шарами. Щойно ви задоволені основною позицією водяного знака, заблокуйте цей шар перед додаванням вторинних. Це запобігає випадковому зміщенню під час роботи з іншими елементами.',
            'Перевіряйте світлі й темні ділянки зображення. Білий водяний знак невидимий на яскравому небі, але чудово читається на темній тіні. Додайте тонку обвідку або колір фону, щоб забезпечити читабельність незалежно від того, що знаходиться під водяним знаком.',
            'Скорочення клавіатури завжди економлять час. Стрілки переміщують вибраний шар на один піксель. Shift+стрілка переміщує на десять пікселів. Клавіша Delete миттєво видаляє вибраний шар. Ці скорочення роблять точне налаштування позиції значно швидшим, ніж перетягування.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Приватність і безпека',
          title: 'Приватність і безпека: чому браузерна обробка має значення',
          paragraphs: [
            'Одне з головних занепокоєнь багатьох творців під час використання онлайн-інструментів — куди насправді потрапляють їхні зображення. У серверних інструментах ваш файл завантажується на сервер провайдера, обробляється там, а потім повертається вам. Це означає, що ваша ще не опублікована робота, клієнтські фото чи конфіденційні зображення товарів проходять через чужу інфраструктуру.',
            'Інструмент водяних знаків Photremium обробляє все локально у вашому браузері. Ваші зображення завантажуються в пам’ять пристрою за допомогою File API браузера і ніколи не передаються через інтернет. Рендеринг водяного знака відбувається на елементі HTML5 canvas, що працює в JavaScript, повністю всередині вкладки браузера. Коли ви закриваєте сторінку або натискаєте «Start Over», усі дані зображення звільняються з пам’яті та видаляються. Нічого не зберігається поза вашим власним пристроєм.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Підсумок',
          title: 'Чому інструмент водяних знаків Photremium заслуговує на місце у вашому регулярному workflow',
          paragraphs: [
            'В інтернеті доступні десятки інструментів для нанесення водяних знаків. Те, що відрізняє інструмент, який варто зберегти в закладках, від того, про який можна забути, зазвичай зводиться до поєднання швидкості, контролю та надійності.',
            'Швидкість важлива, бо нанесення водяного знака не повинно суттєво додавати часу до вашого workflow після обробки. Інструмент Photremium завантажується миттєво, обробляє локально та експортує у повній роздільності за секунди — навіть для великих партій. Немає очікування серверної обробки, немає черги й немає часу рендерингу, який зростає зі збільшенням кількості користувачів онлайн одночасно.',
            'Контроль важливий, бо водяний знак, який виглядає неправильно, гірший за відсутність водяного знака — він робить ваш бренд непрофесійним. Система шарів, керування окремими властивостями на панелі інструментів, попередній перегляд canvas у реальному часі та підтримка клавіатурних скорочень разом дають рівень контролю, який справді можна порівняти зі спеціалізованим десктопним ПЗ.',
            'Надійність важлива, бо ваша неопублікована робота цінна. Знання того, що ваші зображення ніколи не проходять через інтернет на сторонній сервер, означає, що ви можете наносити водяні знаки на фото клієнтів, невипущені зображення товарів і чутливі творчі роботи без жодних побоювань щодо обробки даних, серверних витоків або змін політики хмарного провайдера.',
            'Чи додаєте ви коротке повідомлення про авторське право до одного фото, чи обробляєте цілу зйомку з 200 зображень перед тим, як поділитися клієнтською галереєю, інструмент Watermark Image від Photremium дає вам усе необхідне, щоб зробити це правильно — повністю безкоштовно, повністю приватно й з достатньою творчою гнучкістю, щоб водяний знак виглядав так, ніби він належить цьому зображенню, а не просто накладений поверх нього.',
            'Перейдіть на photremium.com/watermark-image і спробуйте. Ваше перше зображення з водяним знаком буквально за тридцять секунд.',
            'Photremium пропонує набір браузерних інструментів для редагування та обробки зображень. Усі інструменти працюють локально у вашому браузері — ваші зображення залишаються на вашому пристрої.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'Генератор QR-кодів — Генеруйте та Налаштовуйте Безкоштовно | photremium.com',
      inputDesc: 'Генеруйте QR-коди для URL, тексту, WiFi, контактів, електронної пошти та Google Maps.',
      inputKeywords: 'генератор qr кодів, створити qr код, налаштований qr код',
      customizeTitle: 'Налаштування QR-коду — photremium.com',
      customizeDesc: 'Налаштовуйте стиль, кольори, рамку та логотип QR-коду. Завантажте як PNG, JPG, SVG, WEBP або PDF.',
      customizeKeywords: 'налаштувати qr код, стиль qr коду',
    },
    title: 'Генератор QR-кодів',
    desc: 'Генеруйте, налаштовуйте та завантажуйте QR-коди для URL, тексту, WiFi, контактів, пошти та карт.',
    generate: 'Генерувати',
    scanQrCode: 'Сканувати QR-код',
    tabUrl: 'Посилання / URL',
    tabText: 'Текст',
    tabWifi: 'WiFi',
    tabContact: 'Контакт',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'Введіть URL',
    enterText: 'Введіть текст',
    networkName: 'Назва мережі (SSID)',
    password: 'Пароль',
    encryption: 'Шифрування',
    hiddenNetwork: 'Прихована мережа',
    contactName: 'Ім\'я контакту (необов\'язково)',
    phoneNumber: 'Номер телефону',
    emailAddress: 'Адреса електронної пошти',
    subject: 'Тема (необов\'язково)',
    body: 'Текст повідомлення (необов\'язково)',
    searchLocation: 'Пошук місця',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: 'Введіть тут текст…',
    wifiNamePlaceholder: 'Мій WiFi',
    passwordPlaceholder: 'пароль',
    contactPlaceholder: 'Іван Іванов',
    phonePlaceholder: '+38 050 123 45 67',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: 'тема',
    bodyPlaceholder: 'текст листа…',
    locationPlaceholder: 'Шукайте місто, адресу, місце…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'Немає',
    characters: 'символів',
    generateCustomize: 'Генерувати та Налаштувати',
    editQrData: 'Редагувати Дані QR',
    styleShape: 'Стиль та Форма',
    colorTab: 'Кольори',
    framesTab: 'Рамки',
    logoTab: 'Логотип',
    templatesTab: 'Шаблони',
    fileFormatTab: 'Формат Файлу',
    fgColor: 'Колір Переднього Плану',
    bgColor: 'Колір Фону',
    enableGradient: 'Увімкнути Градієнт',
    gradientType: 'Тип Градієнту',
    linear: 'Лінійний',
    radial: 'Радіальний',
    selectFrame: 'Вибрати Рамку',
    selectLogo: 'Вибрати Логотип',
    uploadCustomLogo: 'або завантажити власний логотип',
    uploadImage: 'Завантажити Зображення',
    downloadFormat: 'Формат Завантаження',
    preview: 'Перегляд',
    downloadFormatBtn: 'Завантажити {format}',
    pngDesc: 'Без втрат, підтримка прозорості',
    jpgDesc: 'Популярний/універсальний формат файлу',
    webpDesc: 'Сучасний формат, найкраща якість/розмір',
    svgDesc: 'Масштабована векторна графіка',
    pdfDesc: 'Документ, готовий до друку',
    lat: 'Широта:',
    lng: 'Довгота:',
    qrCode: 'QR-код',
    scanMe: 'Скануй Мене',
    scanHere: 'Скануй Тут',
    blog: {
      card1: {
        title: '1. Що таке QR-код?',
        intro1: 'Повна назва QR-кода - "Quick Response code" (код швидкої відповіді). Оскільки інформація, збережена в ньому, дуже швидко розшифровується, його називають кодом Quick Response (QR).',
        intro2: 'QR-код - це двовимірна цифрова кодування, яку можливо читати тільки машинами. Дані в ньому не можна читати людиною. Він містить блоки для зберігання інформації, такої як текст, номери телефонів, посилання та місцезнаходження на Google Картах тощо.',
        inventionTitle: 'Як був винайдений QR-код:',
        inventionText: 'QR-код був винайдений у 1994 році. Масахіро Хара та його команда працювали в японській компанії Denso Wave, яка виробляла автомобільні запчастини для Toyota. Вони хотіли кодування, який зберігає набагато більше інформації, ніж звичайний штрихкод, тому вони винайшли QR-код.',
        keyFeaturesTitle: 'Ключові особливості QR-коду',
        keyFeatures: [
          {
            title: 'Як працює QR',
            text: 'Ви вводите текст чи посилання, щоб згенерувати QR-код. Генератор QR створює квадратні коробки відповідно до інформації. Кожна коробка являє собою один біт, а кожен біт зберігає один символ.',
          },
          {
            title: 'Структура QR-коду',
            text: 'QR-код містить три великі квадратні коробки для визначення орієнтації QR-коду та одну малу квадратну коробку для зберігання бітів (інформації).',
          },
          {
            title: 'Ємність даних QR-коду',
            text: 'Зазвичай QR-код зберігає більше інформації, ніж штрихкод. QR-код - це просто удосконалена версія штрихкода. За сутністю це двовимірний штрихкод. QR-код зберігає майже 200 символів. Він також може зберігати 400 символів, але може бути важким для сканування. Зберігання більше 400 символів може привести до дуже складного QR-коду, який практично неможливо відсканувати.',
          },
          {
            title: 'Виявлення помилок в QR-кодах',
            text: 'QR-код все ще можна відсканувати, якщо деяка інформація на ньому вівалена або деякі біти перевернені. QR-код використовує техніку виявлення помилок Reed-Solomon для виявлення помилок та їх виправлення після визначення.',
          },
        ],
        errorTitle: 'Рівень виправлення помилок QR-кода:',
        errorIntro: 'Різні технічні методи виявлення та виправлення помилок використовуються в різних випадках, як описано нижче:',
        errorHeaders: {
          level: 'Рівень',
          recovery: 'Спроможність відновлення',
          bestUse: 'Кращий сценарій використання',
        },
        errorRows: [
          {
            level: 'Низький (L)',
            recovery: '~7%',
            useCases: [
              'Ця техніка виправлення помилок використовується, коли QR-код відображається на цифрових екранах, веб-сайтах або в чистому середовищі.',
              'Коли QR-код генерується для невеликої інформації, як-то Gmail, контактний номер або невеликий текст.',
            ],
          },
          {
            level: 'Середній (M)',
            recovery: '~15%',
            useCases: [
              'Для листівок і плакатів, встановлених у чистому середовищі, коли ризик пошкодження незначний.',
            ],
          },
          {
            level: 'Квартиль (Q)',
            recovery: '~25%',
            useCases: [
              'Коли QR-код потрібно встановити в суворому середовищі, як-то на фабриці/вулиці.',
              'Також, коли в центрі потрібно невелике логотип, він закриває деякі біти. Тому ця техніка виправлення помилок необхідна.',
            ],
          },
          {
            level: 'Високий (H)',
            recovery: '~30%',
            useCases: [
              'Використовується, коли можливе важке пошкодження QR-коду.',
              'Коли великі логотипи закривають центр QR-кода.',
              'Також, коли потрібне важке оформлення для QR-кода.',
            ],
          },
        ],
      },
      card2: {
        title: '2. Чому вибрати наш генератор QR-кодів?',
        intro: 'Наш генератор QR-кодів робить генерацію QR-кодів надзвичайно швидкою, безпечною та простою. Ви можете налаштувати свій код, щоб зробити його більш розширеним, професійним та відповідним темі вашого бізнесу. Усі налаштування, від розфарбовування QR-коду до встановлення логотипу в QR-код, пропонуються безплатно назавжди.',
        strengths: [
          {
            title: 'Професійне налаштування:',
            text: 'Ви можете генерувати та налаштовувати стільки QR-кодів, скільки вам потрібно, без будь-яких витрат. Усі функції повністю безплатні. Ви можете застосовувати градієнтні кольори, різні форми для квадратних коробок, спеціальні логотипи та багато інших функцій.',
          },
          {
            title: 'Підтримка кількох форматів:',
            text: 'Наш генератор QR-кодів пропонує кілька форматів завантаження для вашої зручності. Вам просто потрібно вибрати бажаний формат перед завантаженням. Про цей час ми пропонуємо ці формати:',
          },
          {
            title: 'Готові шаблони:',
            text: 'Ви можете використовувати попередньо підготовлені градієнтні кольори та рамки, які робять ваш QR-код професійним.',
          },
          {
            title: 'Підтримка спеціального логотипу:',
            text: 'Ви також можете завантажити свій спеціальний логотип бренду, який автоматично підходить до центру QR-кода. Ви також можете вибрати логотип із вбудованої бібліотеки логотипів, де надаються понад 30 логотипів.',
          },
          {
            title: 'Прямий перегляд:',
            text: 'Під час налаштування ви можете спостерігати всі зміни на панелі прямого перегляду. Ці зміни на панелі попереднього перегляду здійснюються в реальному часі та змінюються динамічно.',
          },
          {
            title: 'Індикатор сканування:',
            text: 'Під час вибору кольорів відповідні попередження та індикатори направлять вас, якщо ви вибрали кольори, які важко сканувати.',
          },
        ],
        formatHeaders: {
          srNo: 'Пор. №',
          formats: 'Формати',
          description: 'Опис',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Без втрат, підтримка прозорості' },
          { no: '2', format: 'JPG', description: 'Популярний, універсальний формат файлу' },
          { no: '3', format: 'WEBP', description: 'Сучасний, найліпша якість/розмір' },
          { no: '4', format: 'SVG', description: 'Масштабована векторна графіка' },
          { no: '5', format: 'PDF', description: 'Документ, готовий до друку' },
        ],
      },
      card3: {
        title: '3. Посібник крок за кроком:',
        step1Intro: 'Спочатку виберіть категорію QR-коду, який ви хочете генерувати. Або ви генеруєте QR-код для контакту, карти, посилання чи тексту. На цей час наш генератор QR-кодів пропонує ці категорії:',
        categories: ['Посилання / URL', 'Текст', 'WiFi', 'Контакт', 'Gmail', 'Google Maps'],
        step2: 'Після вибору категорії вставте свою інформацію у текстовому полі.',
        step3Intro: 'Потім натисніть на "Генерувати та налаштувати", щоб відкрити панель налаштування. На панелі налаштування ви побачите підпанель навігації з наступними параметрами:',
        options: [
          {
            title: 'Стиль та форма:',
            text: 'У цьому розділі ви можете змінити форми квадратних коробок на кілька стилів, як-то заокруглені кути, точки, горизонтальні смуги, вертикальні смуги, малі квадрати та багато інших.',
          },
          {
            title: 'Колір:',
            text: 'У цьому розділі ви можете вибрати спеціальні кольори фону та переднього плану. Щоб зробити ваш QR-код градієнтними кольорами, у вас є можливість увімкнути градієнт, який дозволяє вам застосовувати будь-який градієнтний колір із вбудованої бібліотеки або легко створити свій власний градієнтний колір. Ви також можете змінити кут для лінійного градієнтного кольору. Також підтримується радіальний градієнт. Ви можете додати кілька кольорів, щоб створити професійний ефект градієнту.',
          },
          {
            title: 'Рамки:',
            text: 'Тут ви можете вибрати ідеальну рамку для вашого QR-коду. Усі рамки автоматично пристосовуються до вашого кода. Вам просто потрібно вибрати рамку з вбудованої бібліотеки.',
          },
          {
            title: 'Логотип:',
            text: 'Після вибору рамки ви можете вибрати логотип, який автоматично адаптується до центру QR-кода. Завантаження вашого спеціального логотипу бренду також підтримується.',
          },
          {
            title: 'Шаблони:',
            text: 'Якщо ви не хочете вибирати стиль, форму, колір та рамку окремо, ви можете застосовувати попередньо підготовлені шаблони до вашого QR-кода. Кілька шаблонів преміум-класу є доступними для вашої зручності, які безплатні назавжди.',
          },
          {
            title: 'Формат файлу:',
            text: 'Наприкінці вам потрібно вибрати тип файлу, в якому ви хочете завантажити QR-код. Підтримується кілька поширених форматів, включаючи PNG, WEBP, SVG та PDF тощо.',
          },
          {
            title: 'Редагувати дані QR:',
            text: 'Ви також можете редагувати свої дані QR без втрат у вибраних налаштуваннях.',
          },
        ],
        finalStep: 'Потім просто натисніть кнопку завантаження, і QR-код точно відповідно до ваших налаштувань у вибраному форматі буде завантажений миттєво без будь-яких витрат.',
      },
      card4: {
        title: '4. Переваги:',
        intro: 'QR-код з\'єднує фізичний світ з цифровим досвідом. Це найшвидший спосіб поділитися посиланнями, контактами або вашим місцезнаходженням. Вам просто потрібно відсканувати цей QR-код, щоб правити доступ до інформації миттєво. Тому він дуже популярний у бізнесі та цифровому світі, оскільки є часовоефективним та надзвичайно цілком.',
        benefits: [
          {
            title: 'Підтримка на все життя:',
            text: 'QR-коди працюють назавжди без дати закінчення дії. Вони дають вам збережену інформацію миттєво, коли ви її сканируєте. Оскільки він зберігає жорстко закодовані цифрові інструкції, він ніколи не втрачає свою інформацію.',
          },
          {
            title: 'Підтримка в режимі "без інтернету":',
            text: 'Ви можете сканувати QR-код навіть якщо ви в режимі "без інтернету". Камера вашого мобільного пристрою розшифровує шаблони QR-коду та надає вам інформацію, збережену в ньому.',
          },
          {
            title: 'Нульова вартість:',
            text: 'Оскільки ці коди не потребують перенаправлення сервера чи ресурсів, вони безплатні назавжди.',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'Сканер QR-кодів — Скануйте QR-коди з Камери або Зображення | photremium.com',
      desc: 'Миттєво скануйте QR-коди камерою або завантаживши зображення. Виявляє URL, текст, WiFi, контакти тощо.',
      keywords: 'сканер qr кодів, сканувати qr код, зчитувач qr, qr код онлайн',
    },
    title: 'Сканер QR-кодів',
    desc: 'Миттєво скануйте QR-коди камерою або завантаживши зображення. Швидко та безпечно.',
    generateQrCode: 'Генерувати QR-код',
    scan: 'Сканувати',
    cameraScanner: 'Сканер Камери',
    uploadImage: 'Завантажити Зображення',
    pointCamera: 'Спрямуйте камеру на QR-код',
    startCamera: 'Запустити Камеру',
    loading: 'Завантаження…',
    dropQrImage: 'Перетягніть зображення QR-коду сюди',
    toScan: 'для сканування',
    supportedFormats: 'Підтримує JPG, PNG, GIF, WEBP',
    ctrlVPaste: 'Вставити через Ctrl+V',
    scanFromGallery: 'Сканувати з Галереї',
    instantScanning: 'Миттєве сканування',
    instantScanningDesc: 'Виявлення QR-коду в реальному часі з камери або завантажених зображень',
    private100: '100% Приватно',
    private100Desc: 'Уся обробка відбувається у вашому браузері. Нічого не завантажується',
    multiFormat: 'Багато форматів',
    multiFormatDesc: 'Виявляє URL, текст, WiFi, контакти, email, телефон та інше',
    accessingCamera: 'Отримання доступу до камери…',
    cameraDenied: 'Доступ до камери відхилено. Дозвольте доступ до камери та спробуйте ще раз.',
    noCamera: 'На цьому пристрої не знайдено камери.',
    cameraError: 'Не вдається отримати доступ до камери. Спробуйте ще раз.',
    videoError: 'Не вдалося запустити відтворення відео.',
    switchError: 'Не вдалося переключити камеру.',
    tryAgain: 'Спробувати Ще Раз',
    switchCamera: 'Перемкнути Камеру',
    stop: 'Зупинити',
    noQrFound: 'QR-код Не Знайдено',
    couldNotRead: 'Не вдається прочитати зображення',
    scannerFailed: 'Не вдалося завантажити сканер',
    noQrFoundDesc: 'QR-код не виявлено на зображенні. Спробуйте інше зображення або використайте сканер камери.',
    qrScanned: 'QR-код Відскановано!',
    openLink: 'Відкрити Посилання',
    copied: 'Скопійовано!',
    copy: 'Копіювати',
    share: 'Поділитися',
    scanAgain: 'Сканувати Знову',
    network: 'Мережа',
    password: 'Пароль',
    security: 'Безпека',
    unknown: 'Невідомо',
    typeText: 'Текст',
    typeUrl: 'URL',
    typeWifi: 'Мережа WiFi',
    typeContact: 'Картка контакту',
    typeEmail: 'Електронна пошта',
    typePhone: 'Номер телефону',
    typeSms: 'SMS',
    typeLocation: 'Місцезнаходження',
    blog: {
      tocTitle: 'Зміст',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. Навіщо використовувати сканер QR-коду?',
          paragraphs: [
            'Сканер QR-коду — це, по суті, мобільна камера, яка декодує інформацію, збережену в QR-коді. Вам потрібно лише навести камеру на QR-код; незалежно від орієнтації QR-коду, він прочитає специфічні візерунки, виявить помилки, за потреби виправить їх і відобразить інформацію всередині.',
          ],
          listTitle: 'Типи сканерів QR-коду:',
          bullets: [
            'Веб-сканер QR-коду: Ви можете сканувати QR-код за допомогою онлайн-сканерів, які підтримує ваш браузер. Ви можете отримати інформацію через камеру або скануючи після завантаження зображення. Для автопереадресації та інших розширених функцій ви можете відвідати https://photremium.com.',
            'Мобільні камери: Деякі сучасні смартфони мають вбудований сканер QR-коду у стандартному застосунку камери. Вони можуть отримувати й декодувати інформацію просто скануючи QR-код звичайною камерою.',
            'Застосунки: Існують застосунки, спеціально створені для сканування QR-кодів. Однак для розширеної переадресації та багатьох інших функцій ви можете безкоштовно встановити застосунок за цим посиланням: https://photremium.com.',
            'Апаратні пристрої: Деякі апаратні пристрої також створені для сканування QR-кодів. Такі пристрої широко використовуються у великих торгових центрах для розрахунку товарів.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. Чому обрати наш сканер QR-коду?',
          paragraphs: [
            'Ви можете дослідити багато розширених функцій: від переадресації до копіювання вмісту, декодованого з QR-коду. Ви також можете спробувати багато інших цікавих функцій у нашому сканері QR-коду, як-от:',
          ],
          bullets: [
            'Висока швидкість: Наш сканер QR-коду робить декодування QR-коду надзвичайно швидким. Вам лише потрібно відсканувати QR-код, і наш інструмент миттєво надасть інформацію з розширеною опцією копіювати текст/посилання, відкрити його, якщо виявлено посилання, або автоматично зберегти, якщо виявлено контакт.',
            'Без встановлення: Вам не потрібно встановлювати окремий застосунок, щоб користуватися нашим сканером QR-коду. Ви можете безкоштовно використовувати цей інструмент у локальному браузері.',
            'Кросплатформний доступ: Ви можете користуватися ним на будь-якому пристрої. Не хвилюйтеся щодо версії ОС чи інших вимог. Підтримується на всіх версіях і всіх пристроях.',
            'Підтримка всіх форматів: Усі формати даних, які можуть зберігатися в QR-коді, включно зі звичайним текстом, WiFi, URL, контактами, Gmail і Google Maps тощо, підтримуються нашим інструментом.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Покроковий посібник:',
          steps: [
            {
              heading: '1. Перш за все, оберіть спосіб сканування QR-коду. Для цього є два способи:',
              subSteps: [
                {
                  heading: 'i. Спосіб через камеру',
                  paragraphs: [
                    'Ви можете сканувати QR-код камерою вашого пристрою навіть якщо користуєтеся ноутбуком, ПК або будь-яким пристроєм, що підтримує звичайну камеру. Натискання кнопки “Start Camera” покаже запит на дозвіл; дозвольте цьому сайту використовувати вашу камеру для QR-сканування. Якщо ви випадково відхилили запит або він не з’являється, ви можете надати доступ до камери вручну, виконавши ці кроки:',
                  ],
                  notes: [
                    '➔ Для Chrome (Android / Desktop):',
                    '1. Натисніть три крапки',
                    '2. Перейдіть у Settings',
                    '3. (Пропустіть цей крок на Android) Privacy and Security',
                    '4. Натисніть Site Settings',
                    '5. Потім у розділі permissions натисніть Camera',
                    '6. Знайдіть URL нашого сайту: https://photremium.com/qr-code-scanner',
                    '7. Дозвольте камеру у випадаючому списку.',
                    '➔ Для Safari (iPhone / iOS):',
                    '1. Натисніть іконку AA або Website Settings в адресному рядку.',
                    '2. Виберіть Website Settings.',
                    '3. Натисніть Camera і виберіть Allow.',
                    '4. Якщо все ще заблоковано: перейдіть у iPhone Settings > Safari > Camera і встановіть Ask або Allow.',
                  ],
                },
                {
                  heading: 'ii. Спосіб через галерею',
                  paragraphs: [
                    'Ви можете завантажити зображення QR-коду, щоб отримати його інформацію. Натисніть кнопку “Scan from Gallery”, і відкриється провідник файлів. Потім виберіть зображення QR-коду. Підтримуються всі формати зображень, такі як jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz та .xbm тощо.',
                  ],
                },
              ],
            },
            {
              heading: '2. Коли ви обираєте QR-код, уся інформація відображається; це дозволяє копіювати, ділитися або відкривати посилання, якщо його виявлено. Ви також можете сканувати знову, якщо хочете.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'Переваги сканера QR-коду:.',
          paragraphs: [
            'Сканер QR-коду має кілька переваг у цьому цифровому світі. Він робить оплати, перевірки та доступ до інформації простими й швидкими навіть в офлайн-режимі.',
          ],
          bullets: [
            'Миттєвий доступ до інформації: Сканування QR-коду надає інформацію за мілісекунди. Він декодує шаблони, виявляє помилки й дуже швидко їх усуває, забезпечуючи користувачу надшвидкий досвід.',
            'Безшовна комунікація: У цю епоху розвитку є нагальна потреба у швидкій і безпечній комунікації для невеликої інформації, як-от банківські реквізити та дані про товар тощо. Сканер QR-коду вирішує цю проблему, адже платежі здійснюються скануванням QR-коду. Також Google верифікує мобільний телефон через QR під час створення нового акаунта на ноутбуці.',
            'Е-квитки: На автостанціях, залізничних вокзалах або в аеропортах ви можете легко перевірити квитки без довгого очікування в чергах. Крім того, у багатьох зонах аеропортів встановлюють сканери QR-коду, щоб уникати черг. Це також зменшує потребу в персоналі й автоматично заощаджує бюджет авіакомпанії.',
            'Перевірка автентичності продукту: Просунуті та преміальні бренди розміщують QR-код на своєму товарі. Клієнт може відсканувати цей QR-код, щоб перевірити справжність продукту, чи є він оригінальним.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'Інструмент Розмитості Обличчя — Розмивайте Обличчя на Зображеннях Онлайн | photremium.com',
      uploadDesc: 'Автоматично розмивайте обличчя на зображеннях за допомогою ШІ. Вибирайте інтенсивність, форму або емодзі.',
      uploadKeywords: 'розмитість обличчя, розмити обличчя, виявлення обличчя, інструмент конфіденційності',
      workspaceTitle: 'Інструмент Розмитості Обличчя — photremium.com',
      workspaceDesc: 'Автоматично розмивайте обличчя на зображеннях. 100% безкоштовно.',
      workspaceKeywords: 'розмитість обличчя, виявлення обличчя',
    },
    title: 'Розмитість Обличчя',
    desc: 'Автоматично виявляйте та розмивайте обличчя на зображеннях для захисту конфіденційності.',
    toBlurFaces: 'для розмитості обличчя',
    autoDetection: 'Автоматичне Виявлення',
    autoDetectionDesc: 'ШІ-виявлення обличчя миттєво знаходить усі обличчя',
    customBlur: 'Налаштована Розмитість',
    customBlurDesc: 'Регулюйте інтенсивність, форму та стиль розмитості',
    private100: '100% Конфіденційно',
    private100Desc: 'Вся обробка відбувається локально у браузері',
    blurTools: 'Інструменти Розмитості',
    faces: 'Обличчя',
    faceDetection: 'Виявлення Обличчя',
    detecting: 'Виявлення...',
    autoDetectFaces: 'Автоматично Виявити Обличчя',
    exitManualMode: 'Вийти з Ручного Режиму',
    manualSelect: 'Ручний Вибір',
    nFaceRegions: 'Знайдено {n} ділянок обличчя',
    noFacesDetected: 'Обличчя не виявлено — використайте ручний режим',
    manualHint: 'Натисніть та перетягніть для малювання прямокутника над областю для розмивання.',
    blurType: 'Тип Розмитості',
    blur: 'Розмитість',
    emoji: 'Емодзі',
    blurIntensity: 'Інтенсивність Розмитості',
    strength: 'Сила',
    blurShape: 'Форма Розмитості',
    rectangle: 'Прямокутник',
    ellipse: 'Еліпс',
    circle: 'Коло',
    chooseEmoji: 'Вибрати Емодзі',
    blurRegionsN: 'Ділянки Розмитості ({n})',
    faceN: 'Обличчя {n}',
    manualRegionN: 'Ручна Ділянка {n}',
    manualN: 'Ручне {n}',
    clearAllRegions: 'Очистити Всі Ділянки',
    processingDots: 'Обробка...',
    downloadBlurred: 'Завантажити Розмите Зображення',
    downloadNImages: 'Завантажити {n} Зображень',
    downloadDialogTitle: 'Не Всі Зображення Відредаговано',
    downloadDialogText: 'Відредаговано {edited} з {total}.',
    downloadAll: 'Завантажити Все',
    removeRegion: 'Видалити Ділянку',
    region: 'Ділянка',
    notAllEdited: 'Не Всі Зображення Відредаговано',
    editedXofY: 'Відредаговано {edited} з {total}.',
    nextImage: 'Наступне Зображення',
  },

  faqData: {
    imageConverter: [
      { q: 'Які формати зображень підтримуються для конвертації?', a: 'Ми підтримуємо JPG, PNG, WEBP, SVG, GIF, BMP, ICO та TIFF. Ви можете миттєво конвертувати між цими форматами у браузері.' },
      { q: 'Чи зберігається якість зображення під час конвертації?', a: 'Для форматів без втрат, як PNG, якість повністю зберігається. Для форматів зі стисненням, як JPG та WEBP, ми використовуємо оптимізовані налаштування кодування.' },
      { q: 'Чи є обмеження за розміром або кількістю файлів?', a: 'Жодних суворих обмежень. Ви можете завантажувати кілька зображень одночасно та конвертувати їх пакетно.' },
      { q: 'Чи безпечні мої дані? Чи зображення надсилаються на сервер?', a: 'Абсолютно. Вся обробка відбувається у вашому браузері. Ваші зображення ніколи не покидають пристрій.' },
      { q: 'Чи можна конвертувати прозорий PNG у JPG?', a: 'Так. Оскільки JPG не підтримує прозорість, прозорі ділянки за замовчуванням заповнюються білим фоном.' },
    ],
    imageCompressor: [
      { q: 'Чи зменшить стиснення якість зображення?', a: 'Ні, стиснення не впливає помітно на якість, якщо не перевищувати рекомендовані межі. Якість підкажуть індикатори: i. Стиснення 1% до 40%: зелений індикатор із повідомленням «Хороша якість». ii. Стиснення 41% до 60%: жовтий індикатор із повідомленням «Нормальна якість». Цей діапазон зазвичай найрекомендованіший. iii. Стиснення 61% до 100%: система покаже червоне попередження «Погана якість», і погіршення може бути помітним.' },
      { q: 'Які формати зображень підтримуються для стиснення?', a: 'Наш інструмент підтримує всі наведені формати:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Чи можу я стискати багато зображень одночасно?', a: 'Так, звісно. Ви можете стискати багато зображень одночасно (навіть 100+), якщо пристрій це підтримує. Оскільки стиснення використовує ресурси системи, продуктивніший ноутбук, ПК або телефон працюватиме швидше. Якщо пристрій слабший, можна стискати пакетами — інструмент лишається безкоштовним навіть при багатьох підходах.' },
      { q: 'Чи зберігаєте або завантажуєте ви наші зображення на свої сервери?', a: 'Ні, ми ніколи не завантажуємо і не зберігаємо ваші зображення на наших серверах. Усе стискається локально у вашому браузері. Файли не залишають ваш пристрій, тож ви можете спокійно обробляти приватні або особисті фото.' },
      { q: 'Цей інструмент стиснення зображень безкоштовний?', a: 'Так, наш інструмент повністю безкоштовний назавжди. Ми не просимо жодної оплати. Прихованих платежів немає. Усі функції, включно зі стисненням багатьох зображень, доступні безкоштовно.' },
    ],
    cropImage: [
      { q: 'Чи погіршується якість зображення після обрізання?', a: 'Ні, обрізання зображення зовсім не впливає на його візуальну якість. Обрізання лише видаляє небажану частину. Воно ніколи не змінює пікселі тієї частини, яка залишається після обрізання. Тому ви можете обрізати зображення в оригінальній якості без жодних пошкоджень пікселів.' },
      { q: 'Які формати зображень підтримує інструмент обрізання?', a: 'Ви можете обрати зображення в будь-якому форматі, оскільки наш інструмент обрізання підтримує майже всі формати зображень. Вони наведені нижче:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Чи завантажуються мої зображення на ваш сервер?', a: 'Ні, вся обробка виконується у вашому локальному браузері. Ваші зображення ніколи не завантажуються на наш сервер, тому що вони не залишають ваш пристрій. Отже, ви можете обрізати приватні зображення нашим інструментом без жодного ризику.' },
      { q: 'Чи можна обрізати кілька зображень одночасно?', a: 'Так, ви можете обрізати кілька зображень (навіть 100+) одночасно, якщо це підтримує ваша система. Оскільки обрізання використовує ресурси системи, на продуктивному ноутбуці, ПК або телефоні можна обробляти багато зображень за раз. Якщо у вас слабший пристрій, ви можете обрізати зображення пакетами, адже інструмент безкоштовний навіть за інтенсивного використання.' },
      { q: 'Чи цей інструмент обрізання зображень безкоштовний?', a: 'Так, цей інструмент обрізання зображень повністю безкоштовний назавжди. Ви можете користуватися ним будь-де, будь-коли та на будь-якому пристрої. Ви отримаєте адаптивний дизайн для всіх пристроїв, і з вас ніколи не попросять оплату за преміум-функції. Усі функції повністю безкоштовні без прихованих платежів.' },
    ],
    resizeImage: [
      { q: 'Чи можу я змінювати розмір кількох зображень одночасно?', a: 'Так, звичайно. Наш інструмент підтримує одночасну зміну розміру багатьох зображень. Ви можете завантажити стільки файлів, скільки підтримує ваш пристрій, а AI-рушій обробить їх разом. На слабших пристроях краще працювати пакетами, щоб уникнути підвисань. Усе виконується локально без завантаження на сервер, тож приватність збережена.' },
      { q: 'Цей інструмент зміни розміру безкоштовний?', a: 'Так, цей інструмент повністю безкоштовний назавжди. Платна підписка для преміум-функцій не потрібна. Під час завантаження змінених зображень також немає прихованих платежів.' },
      { q: 'Чи погіршується якість під час зміни розміру?', a: '✅Decrease Size (downscale): Зменшення розміру не погіршує візуальну якість зображення. У багатьох випадках зменшене зображення може навіть виглядати чіткіше. Тому зменшення до меншого розміру зазвичай не призводить до втрати якості.\n❌Increase Size (upscale): Збільшення зображення понад оригінальний розмір може вплинути на візуальну якість. Чим сильніше збільшення, тим вища ймовірність втрати якості.' },
      { q: 'Чи безпечний цей інструмент?', a: 'Так, наш інструмент безпечний, особливо для особистих і чутливих зображень. Уся обробка виконується локально на вашому пристрої, і жодні дані його не залишають. Ви можете змінювати розмір без ризиків для конфіденційності.' },
      { q: 'Які формати зображень підтримуються?', a: 'Наш інструмент зміни розміру підтримує всі формати зображень. Ви можете вибирати файли у таких форматах:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'Як працює видалення фону?', a: 'Ми використовуємо вдосконалені моделі ШІ, що працюють безпосередньо у браузері, для виявлення об\'єкту та відділення його від фону.' },
      { q: 'Чи працює для складних фонів?', a: 'Так. Модель ШІ справляється з різноманітними сценами. Найкращі результати досягаються при чіткому контрасті між об\'єктом та фоном.' },
      { q: 'Чи можна видалити фон з кількох зображень одночасно?', a: 'Так. Завантажте кілька зображень, і інструмент обробить їх послідовно.' },
      { q: 'Який формат виводу?', a: 'Вивід завжди є файлом PNG з прозорим фоном.' },
      { q: 'Чи надсилаються мої зображення на сервер?', a: 'Ні. Модель ШІ повністю працює у браузері за допомогою WebAssembly.' },
    ],
    watermarkImage: [
      { q: '1. Чи безкоштовний інструмент Photremium для водяних знаків?', a: 'Так — інструмент на photremium.com/watermark-image безкоштовний і не потребує облікового запису чи підписки. Ви можете додавати водяні знаки до окремих зображень або пакетів без обмежень.' },
      { q: '2. Скільки зображень можна обробляти одночасно?', a: 'Інструмент підтримує пакетну обробку. Ви можете перетягнути папку зображень або вибрати десятки файлів — практичне обмеження задає памʼять пристрою.' },
      { q: '3. Які формати входу та виходу підтримуються?', a: 'Підтримуються формати, що читаються File API: JPEG, JPG, PNG, WEBP, GIF (статичний), BMP та SVG. Вихідний файл зберігає формат оригіналу.' },
      { q: '4. Чи буде водяний знак виглядати однаково на зображеннях з різною роздільністю?', a: 'Так. Двигун пропорційного позиціонування обчислює відносні позиції і масштаб, зберігаючи зовнішній вигляд водяного знака у всьому пакеті.' },
      { q: '5. Чи можна використовувати власний логотип замість тексту?', a: 'Так. Кнопка "Add Image" дозволяє завантажити PNG з прозорим фоном, який збереже прозорість і буде використаний як шар водяного знака.' },
      { q: '6. Як зробити водяний знак напівпрозорим?', a: 'Виберіть шар водяного знака на полотні і налаштуйте повзунок прозорості. 30–50% зазвичай дає делікатний професійний результат.' },
      { q: '7. Чи підтримується кілька шарів водяних знаків?', a: 'Так — система шарів дозволяє додавати необмежену кількість шарів, кожен з власними налаштуваннями.' },
      { q: '8. Що робить функція tiling і коли її використовувати?', a: 'Tiling повторює водяний знак за сіткою по всьому зображенню; корисно при бажанні запобігти несанкціонованому використанню.' },
      { q: '9. Чи працює інструмент на мобільних пристроях?', a: 'Так — інтерфейс адаптивний: мініатюри стають стрічкою з прокруткою, панель налаштувань виймається знизу, елементи керування підтримують сенсор.' },
      { q: '10. Чи приватні мої зображення і чи відправляються вони на сервер?', a: 'Зображення не покидають ваш пристрій. Весь робочий процес виконується локально в браузері з використанням Canvas API; ніякого завантаження даних не відбувається.' },
    ],
    qrCodeGenerator: [
      { q: 'Чи QR код закінчується?', a: 'Ні, ці QR коди не стирають і гарантують підтримку на все життя. Оскільки вони зберігають жорстко закодовані інструкції у вигляді бітів всередині квадратних полів, інформація, що зберігається в них, не може бути змінена або видалена. Ви можете отримати доступ до інформації в кодексі, просто сканувавши його будь-якою камерою навіть після років.' },
      { q: 'Чому мій QR код не сканується?', a: 'Ваш QR код може не сканюватися з таких причин: i. Низька контрастність: Якщо ви виберете подібні кольори фону та переднього плану, це впливає на видимість QR кода і спричинює аварію сканування. Але наш інструмент буде вас вести під час налаштування щодо низької контрастності або будь-якої іншої проблеми зі сканування. ii. Великі дані: Якщо ви генеруєте QR код для дуже великого тексту або даних, він стає дуже складним і спричинює проблеми під час сканування. Валідатор довжини тексту буде вас вести щодо оптимальної довжини тексту під час генерування QR кода. iii. Розмита друк: Переконайтеся, що ви завантажи ваш QR код в форматі високої роздільності, як PNG або SVG, які вже підтримуються нашим інструментом.' },
      { q: 'Чи можу я додати логотип у QR код?', a: 'Звісно, ви можете додати власний логотип або вибрати один з вбудованої бібліотеки логотипів для вашого QR кода. Ваш вибраний логотип буде автоматично тримати в центрі QR кода.' },
      { q: 'Як я можу сканувати QR код?', a: 'Ви можете сканувати QR код, використовуючи камеру свого мобільного телефону. Але для автоматичного перенаправлення на посилання та багато інших розширених функцій, ви можете відвідати наш сканер QR кодів, використовуючи посилання https://photremium.com/qr-code-scanner безкоштовно.' },
      { q: 'Скільки QR кодів я можу генерувати безкоштовно?', a: 'НЕОБМЕЖЕНО! ви можете генерувати кілька QR кодів безкоштовно. Всі функції, налаштування та шаблони безкоштовні назавжди для всіх. Немає потреби в підписці для користування функціями преміум.' },
      { q: 'Чи мне потрібно входити / реєструватися для генерування QR кода?', a: 'Ні, просто введіть свій текст, генеруйте QR код та завантажте після налаштування. Нема потреби в вході чи реєстрації, оскільки всі функції можна повністю скористатися безкоштовно.' },
    ],
    qrCodeScanner: [
      { q: 'Чи можу я сканувати QR-код із збережених зображень і скріншотів?', a: '**Так**, ви можете сканувати QR-код із збережених зображень або скріншотів. Наш сканер QR-коду https://photremium.com/qr-code-scanner дозволяє сканувати QR-код із галереї. Вам потрібно лише вибрати зображення, і ви отримаєте всю інформацію, зчитану з цього QR-коду.' },
      { q: 'Чи потрібно встановлювати застосунок для сканера QR-коду?', a: '**Ні**, наш веб-сканер QR-коду дозволяє сканувати QR-код без встановлення будь-якого застосунку. Ви можете безкоштовно користуватися нашим розширеним сканером QR-коду на будь-якому пристрої.' },
      { q: 'Чому сканер не розпізнає QR-код?', a: 'Ваш QR-код не сканується з однієї з таких причин: i. Недостатнє освітлення: Сканування QR-коду при слабкому світлі може спричиняти проблеми. Увімкніть ліхтарик і збільште яскравість, якщо скануєте з екрана. ii. Відстань: Сканування QR-коду з невідповідної відстані також викликає проблеми. Оптимальна відстань для сканування QR-коду — близько 10 дюймів (25cm). iii. Брудні лінзи камери: QR-код також може не скануватися через брудні лінзи. Очистіть лінзи перед скануванням. “Бачите квадратну сітку у сканері? Просто розмістіть QR-код у ній, щоб успішно його відсканувати.”' },
      { q: 'Чи сканує цей інструмент інвертований або кольоровий QR-код?', a: '**Так**, ви можете сканувати QR у будь-якому кольорі або орієнтації. Однак, якщо контраст між фоном і переднім планом низький, це може ускладнити сканування.' },
      { q: 'Цей інструмент безкоштовний?', a: '**Так**, цей інструмент повністю безкоштовний у використанні. Ви можете безлімітно сканувати QR-коди безкоштовно назавжди.' },
    ],
    faceBlur: [
      { q: 'Як працює виявлення обличчя?', a: 'Модель виявлення обличчя на основі ШІ працює безпосередньо у вашому браузері. Вона ідентифікує обличчя на зображеннях.' },
      { q: 'Чи можна вибрати, які обличчя розмивати?', a: 'Так. Після виявлення кожна ділянка обличчя підсвічується, і ви можете вибрати обличчя для розмивання.' },
      { q: 'Які стилі розмивання доступні?', a: 'Ви можете вибрати розмивання Гауса, піксепізацію або накладення суцільного кольору та регулювати інтенсивність.' },
      { q: 'Чи можна розмивати обличчя на кількох зображеннях одночасно?', a: 'Так. Завантажте кілька зображень, налаштуйте ділянки розмивання та завантажте всі оброблені зображення.' },
      { q: 'Чи надсилаються мої фотографії на віддалені сервери?', a: 'Ні. Модель ШІ працює у вашому браузері за допомогою WebAssembly.' },
    ],
    photoEditor: [
      { q: 'Які функції редагування доступні?', a: 'Регулювання яскравості, контрасту, насиченості, застосування фільтрів, додавання тексту, накладень, рамок та стікерів — все у браузері.' },
      { q: 'Чи підтримується скасування та повторення?', a: 'Так. Редактор підтримує повну історію скасування/повторення.' },
      { q: 'Які формати файлів можна редагувати та експортувати?', a: 'Ви можете редагувати JPG, PNG, WEBP та інші популярні формати.' },
      { q: 'Чи працює редактор на телефонах?', a: 'Так. Редактор повністю адаптивний та зручний для сенсорних екранів.' },
      { q: 'Чи зберігаються мої зображення на сервері?', a: 'Ні. Все редагування відбувається локально.' },
    ],
  },
};

export default uk;
